[
  {
    "id": "ca-ab-alberta-reproductive-centre",
    "name": "Alberta Reproductive Centre",
    "address": {
      "id": "addr-ca-ab-alberta-reproductive-centre",
      "address1": "#201, 17203 103 Avenue NW",
      "address2": null,
      "city": "Edmonton",
      "state": "AB",
      "postalCode": "T5S 1J4",
      "country": "CA"
    },
    "headline": "Alberta Reproductive Centre",
    "images": [
      {
        "id": "ca-ab-alberta-reproductive-centre-image-1",
        "url": "https://albertafertility.ca/wp-content/uploads/2023/08/ARC-Waiting-Room-1-scaled.jpeg",
        "name": "Alberta Reproductive Centre"
      },
      {
        "id": "ca-ab-alberta-reproductive-centre-image-2",
        "url": "https://albertafertility.ca/wp-content/uploads/2023/01/Main-Page-Image-2-1024x792.png",
        "name": "attachment-large size-large wp-image-3899"
      },
      {
        "id": "ca-ab-alberta-reproductive-centre-image-3",
        "url": "https://albertafertility.ca/wp-content/uploads/2023/08/consultation-light-brown-1-pt-1.png",
        "name": "attachment-full size-full wp-image-4980"
      },
      {
        "id": "ca-ab-alberta-reproductive-centre-image-4",
        "url": "https://albertafertility.ca/wp-content/uploads/2023/08/SA-light-brown-1-pt-1.png",
        "name": "attachment-full size-full wp-image-4982"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://albertafertility.ca/",
    "email": null,
    "phone": "587-442-0461",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "A fertility clinic based in Edmonton providing fertility support, IUI, IVF, preimplantation genetic testing, and prenatal screening.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "15:30"
      },
      "tue": {
        "open": "07:30",
        "close": "15:30"
      },
      "wed": {
        "open": "07:30",
        "close": "15:30"
      },
      "thu": {
        "open": "07:30",
        "close": "15:30"
      },
      "fri": {
        "open": "07:30",
        "close": "15:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-anova-fertility-and-reproductive-health-toronto",
    "name": "Anova Fertility & Reproductive Health",
    "address": {
      "id": "addr-ca-on-anova-fertility-and-reproductive-health-toronto",
      "address1": "25 Sheppard Ave. West",
      "address2": "Suites 650 & 690, Toronto, ON M2N 6S6",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Anova Fertility & Reproductive Health",
    "images": [
      {
        "id": "ca-on-anova-fertility-and-reproductive-health-toronto-image-1",
        "url": "https://anovafertility.com/wp-content/uploads/2026/01/Anova-Lab-Specimin.jpg",
        "name": "Anova Lab Specimin b-lazy force-load sketch-image"
      },
      {
        "id": "ca-on-anova-fertility-and-reproductive-health-toronto-image-2",
        "url": "https://anovafertility.com/wp-content/uploads/2024/08/I-am-a-Referring-Doctor-Sketch.png",
        "name": "I am a Referring Doctor Sketch b-lazy force-load sketch-image"
      },
      {
        "id": "ca-on-anova-fertility-and-reproductive-health-toronto-image-3",
        "url": "https://anovafertility.com/wp-content/uploads/2024/08/Pregnant-Couple-Holding-Stomach.png",
        "name": "Pregnant Couple Holding Stomach b-lazy force-load sketch-image"
      },
      {
        "id": "ca-on-anova-fertility-and-reproductive-health-toronto-image-4",
        "url": "https://anovafertility.com/wp-content/uploads/2024/12/Marjorie-in-Pink-Jacket.png",
        "name": "Marjorie in Pink Jacket b-lazy force-load sketch-image"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.anovafertility.com/",
    "email": null,
    "phone": "4162254440",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Anova provides fertility services including personalized treatments, support, and resources to assist you in achieving your dream of starting a family.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "15:30"
      },
      "tue": {
        "open": "07:30",
        "close": "15:30"
      },
      "wed": {
        "open": "07:30",
        "close": "15:30"
      },
      "thu": {
        "open": "07:30",
        "close": "15:30"
      },
      "fri": {
        "open": "07:30",
        "close": "15:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-astra-fertility-mississauga-mississauga",
    "name": "ASTRA Fertility- Mississauga",
    "address": {
      "id": "addr-ca-on-astra-fertility-mississauga-mississauga",
      "address1": "4303 Village Centre Court",
      "address2": "Mississauga, ON L4Z 1S2",
      "city": "Mississauga",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "ASTRA Fertility- Mississauga",
    "images": [
      {
        "id": "ca-on-astra-fertility-mississauga-mississauga-image-1",
        "url": "https://astrafertility.com/wp-content/uploads/2020/03/Astra-Fertility-homepage-slider.jpg",
        "name": "astra fertility homepage slider attachment-sp-section-bg size-sp-section-bg"
      },
      {
        "id": "ca-on-astra-fertility-mississauga-mississauga-image-2",
        "url": "https://astrafertility.com/wp-content/uploads/2020/05/Astra-Fertility-what-sets-us-apart-image.jpg",
        "name": "astra fertility what set us a part image vc_single_image-img attachment-full"
      },
      {
        "id": "ca-on-astra-fertility-mississauga-mississauga-image-3",
        "url": "https://astrafertility.com/wp-content/uploads/2020/03/Accredition-Canada.png",
        "name": "accredition canada vc_single_image-img attachment-full"
      },
      {
        "id": "ca-on-astra-fertility-mississauga-mississauga-image-4",
        "url": "https://astrafertility.com/wp-content/uploads/2020/04/astra-fertility-contact.jpg",
        "name": "astra fertility contact attachment-sp-section-bg size-sp-section-bg"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.astrafertility.com/",
    "email": null,
    "phone": "9059496999",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Astra Fertility is a state-of-the-art fertility clinic providing services in Mississauga, Brampton, Milton, Bolton, and Belleville.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-astra-women-s-health-and-ambulatory-surgery-centre-brampton",
    "name": "Astra Women’s Health & Ambulatory Surgery Centre",
    "address": {
      "id": "addr-ca-on-astra-women-s-health-and-ambulatory-surgery-centre-brampton",
      "address1": "300 Main Street North",
      "address2": "Brampton, ON L6V 4H6",
      "city": "Brampton",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Astra Women’s Health & Ambulatory Surgery Centre",
    "images": [
      {
        "id": "ca-on-astra-women-s-health-and-ambulatory-surgery-centre-brampton-image-1",
        "url": "https://astrawhasc.com/wp-content/uploads/2023/02/ezgif.com-gif-maker-7-1.webp",
        "name": "vc_single_image-img attachment-medium"
      },
      {
        "id": "ca-on-astra-women-s-health-and-ambulatory-surgery-centre-brampton-image-2",
        "url": "https://astrawhasc.com/wp-content/uploads/2025/02/Screenshot-2025-02-18-at-5.54.56%E2%80%AFPM.jpg",
        "name": "vc_single_image-img attachment-full"
      },
      {
        "id": "ca-on-astra-women-s-health-and-ambulatory-surgery-centre-brampton-image-3",
        "url": "https://astrawhasc.com/wp-content/uploads/2023/04/Frame-1099-2.webp",
        "name": "Ambulatory Hysteroscopy vc_single_image-img attachment-full"
      },
      {
        "id": "ca-on-astra-women-s-health-and-ambulatory-surgery-centre-brampton-image-4",
        "url": "https://astrawhasc.com/wp-content/uploads/2023/07/Frame-1104.webp",
        "name": "Expert Hysteroscopy Specialist vc_single_image-img attachment-full"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.astrawhasc.com",
    "email": null,
    "phone": "9059496999",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Astra women’s health surgery centre: leading ambulatory hysteroscopy by expert specialists. High-quality care & minimally invasive surgeries. Call now.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "09:00",
        "close": "18:00"
      },
      "tue": {
        "open": "09:00",
        "close": "18:00"
      },
      "wed": {
        "open": "09:00",
        "close": "18:00"
      },
      "thu": {
        "open": "09:00",
        "close": "18:00"
      },
      "fri": {
        "open": "09:00",
        "close": "18:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-ns-atlantic-fertility",
    "name": "Atlantic Fertility",
    "address": {
      "id": "addr-ca-ns-atlantic-fertility",
      "address1": "1535 Dresden Row",
      "address2": "Suite 213",
      "city": "Halifax",
      "state": "NS",
      "postalCode": "B3J 3T1",
      "country": "CA"
    },
    "headline": "Atlantic Fertility",
    "images": [
      {
        "id": "ca-ns-atlantic-fertility-image-1",
        "url": "https://images.squarespace-cdn.com/content/v1/5fb58782cebfa2506e167002/1606516823247-PBHM1J0T59MD1CV83XCG/DSC06912.jpg",
        "name": "Atlantic Fertility team image"
      },
      {
        "id": "ca-ns-atlantic-fertility-image-2",
        "url": "https://images.squarespace-cdn.com/content/v1/5fb58782cebfa2506e167002/1606516972038-DBPAT7ZDSZ99DVNZE3V1/mike.jpg",
        "name": "Atlantic Fertility team image"
      },
      {
        "id": "ca-ns-atlantic-fertility-image-3",
        "url": "https://images.squarespace-cdn.com/content/v1/5fb58782cebfa2506e167002/1606516706954-CPJ0SSSM8DVJF1ZPVJ0P/heather.jpg",
        "name": "Atlantic Fertility team image"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://atlanticfertility.ca/",
    "email": "info@atlanticfertility.ca",
    "phone": "902-404-8600",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Our team is here to help you build the family you desire with a full range of therapies.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-sk-aurora-reproductive-care",
    "name": "Aurora Reproductive Care",
    "address": {
      "id": "addr-ca-sk-aurora-reproductive-care",
      "address1": "103 Hospital Drive",
      "address2": "Royal University Hospital",
      "city": "Saskatoon",
      "state": "SK",
      "postalCode": "S7N 0W8",
      "country": "CA"
    },
    "headline": "Aurora Reproductive Care",
    "images": [
      {
        "id": "ca-sk-aurora-reproductive-care-image-1",
        "url": "https://auroraivf.ca/me/themes/aurora/img/feature1.jpg",
        "name": "Office Virtual Tour"
      },
      {
        "id": "ca-sk-aurora-reproductive-care-image-2",
        "url": "https://auroraivf.ca/me/themes/aurora/img/feature2.jpg",
        "name": "Set An Appointment"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Hospital-based",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://auroraivf.ca/",
    "email": null,
    "phone": "306-653-5222",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-barrie-fertility-centre-barrie",
    "name": "Barrie Fertility Centre",
    "address": {
      "id": "addr-ca-on-barrie-fertility-centre-barrie",
      "address1": "1 Quarry Ridge Road",
      "address2": "Suite 201, Barrie, ON L4M 7G1",
      "city": "Barrie",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Barrie Fertility Centre",
    "images": [
      {
        "id": "ca-on-barrie-fertility-centre-barrie-image-1",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/og-image.jpg",
        "name": "Barrie Fertility Centre"
      },
      {
        "id": "ca-on-barrie-fertility-centre-barrie-image-2",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/dr-andrew-browning.jpg",
        "name": "Barrie Fertility Centre"
      },
      {
        "id": "ca-on-barrie-fertility-centre-barrie-image-3",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/Julia-Tremblay.png",
        "name": "Julia Tremblay"
      },
      {
        "id": "ca-on-barrie-fertility-centre-barrie-image-4",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/Ashley-Revoy.png",
        "name": "Ashley Revoy"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.barriefertilitycentre.com/",
    "email": null,
    "phone": "7057287784",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Barrie Fertility Centre is a leading fertility clinic in Barrie, Ontario. We offer advanced reproductive support (ART) and technology. Book today.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "14:00"
      },
      "tue": {
        "open": "07:00",
        "close": "14:00"
      },
      "wed": {
        "open": "07:00",
        "close": "14:00"
      },
      "thu": {
        "open": "07:00",
        "close": "14:00"
      },
      "fri": {
        "open": "07:00",
        "close": "14:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-centre-for-human-assisted-reproductive-medicine-inc-charm-etobicoke",
    "name": "Centre for Human Assisted Reproductive Medicine Inc. ( CHARM )",
    "address": {
      "id": "addr-ca-on-centre-for-human-assisted-reproductive-medicine-inc-charm-etobicoke",
      "address1": "101 Westmore Drive",
      "address2": "Suite 201, Etobicoke, ON M9V 3Y6",
      "city": "Etobicoke",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Centre for Human Assisted Reproductive Medicine Inc. ( CHARM )",
    "images": [
      {
        "id": "ca-on-centre-for-human-assisted-reproductive-medicine-inc-charm-etobicoke-image-1",
        "url": "https://www.charmfertility.com/wp-content/uploads/2019/05/fertility_miracle_services.jpg",
        "name": "Fertility services by CHARM Ferility fertility_miracle_services rev-slidebg"
      },
      {
        "id": "ca-on-centre-for-human-assisted-reproductive-medicine-inc-charm-etobicoke-image-2",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/in_vitro_fertilization-740x425.jpg",
        "name": "In Vitro Fertilization (IVF) attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      },
      {
        "id": "ca-on-centre-for-human-assisted-reproductive-medicine-inc-charm-etobicoke-image-3",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/Intrauterine-Insemination-740x425.jpg",
        "name": "Intrauterine Insemination (IUI) attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      },
      {
        "id": "ca-on-centre-for-human-assisted-reproductive-medicine-inc-charm-etobicoke-image-4",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/ovulation_induction--740x425.jpg",
        "name": "Ovulation Induction attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.charmfertility.com/",
    "email": null,
    "phone": "4167482800",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "CHARM Fertility offers IVF, IUI & advanced fertility care in Oakville, Etobicoke & Brampton. Personalized treatment to support your journey to parenthood.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-charm-fertility-brampton-brampton",
    "name": "CHARM Fertility Brampton",
    "address": {
      "id": "addr-ca-on-charm-fertility-brampton-brampton",
      "address1": "244 Queen Street East",
      "address2": "Brampton, ON L6V 1B9",
      "city": "Brampton",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "CHARM Fertility Brampton",
    "images": [
      {
        "id": "ca-on-charm-fertility-brampton-brampton-image-1",
        "url": "https://www.charmfertility.com/wp-content/uploads/2019/05/fertility_miracle_services.jpg",
        "name": "Fertility services by CHARM Ferility fertility_miracle_services rev-slidebg"
      },
      {
        "id": "ca-on-charm-fertility-brampton-brampton-image-2",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/in_vitro_fertilization-740x425.jpg",
        "name": "In Vitro Fertilization (IVF) attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      },
      {
        "id": "ca-on-charm-fertility-brampton-brampton-image-3",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/Intrauterine-Insemination-740x425.jpg",
        "name": "Intrauterine Insemination (IUI) attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      },
      {
        "id": "ca-on-charm-fertility-brampton-brampton-image-4",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/ovulation_induction--740x425.jpg",
        "name": "Ovulation Induction attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.charmfertility.com",
    "email": null,
    "phone": "9054578558",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "CHARM Fertility offers IVF, IUI & advanced fertility care in Oakville, Etobicoke & Brampton. Personalized treatment to support your journey to parenthood.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-charm-fertility-oakville-oakville",
    "name": "CHARM Fertility Oakville",
    "address": {
      "id": "addr-ca-on-charm-fertility-oakville-oakville",
      "address1": "627 Lyons Lane",
      "address2": "Level B, Oakville, ON L6J 2Y1",
      "city": "Oakville",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "CHARM Fertility Oakville",
    "images": [
      {
        "id": "ca-on-charm-fertility-oakville-oakville-image-1",
        "url": "https://www.charmfertility.com/wp-content/uploads/2019/05/fertility_miracle_services.jpg",
        "name": "Fertility services by CHARM Ferility fertility_miracle_services rev-slidebg"
      },
      {
        "id": "ca-on-charm-fertility-oakville-oakville-image-2",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/in_vitro_fertilization-740x425.jpg",
        "name": "In Vitro Fertilization (IVF) attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      },
      {
        "id": "ca-on-charm-fertility-oakville-oakville-image-3",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/Intrauterine-Insemination-740x425.jpg",
        "name": "Intrauterine Insemination (IUI) attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      },
      {
        "id": "ca-on-charm-fertility-oakville-oakville-image-4",
        "url": "https://www.charmfertility.com/wp-content/uploads/2016/11/ovulation_induction--740x425.jpg",
        "name": "Ovulation Induction attachment-felizia-thumb-services_2 size-felizia-thumb-services_2 wp-post-image"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.charmfertility.com",
    "email": null,
    "phone": "9058447238",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "CHARM Fertility offers IVF, IUI & advanced fertility care in Oakville, Etobicoke & Brampton. Personalized treatment to support your journey to parenthood.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-qc-chum-centre-reproduction",
    "name": "CHUM Centre de reproduction",
    "address": {
      "id": "addr-ca-qc-chum-centre-reproduction",
      "address1": "",
      "address2": null,
      "city": "Montreal",
      "state": "QC",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "CHUM Centre de reproduction",
    "images": [
      {
        "id": "ca-qc-chum-centre-reproduction-image-1",
        "url": "https://www.chumontreal.qc.ca/sites/default/files/styles/news_slider_5_4_desktop/public/2026-06/Le%20pouvoir%20de%20la%20collaboration%20a%CC%80%20l%E2%80%99honneur%20au%20colloque%20annuel%20et%20a%CC%80%20l%E2%80%99AGA%20du%20CM.jpeg?itok=jg17tqiq",
        "name": "Le pouvoir de la collaboration à l’honneur au colloque annuel et à l’AGA du CM"
      },
      {
        "id": "ca-qc-chum-centre-reproduction-image-2",
        "url": "https://www.chumontreal.qc.ca/themes/custom/chum/images/WEB_image_OG_630x1200.png",
        "name": "CHUM Centre de reproduction"
      },
      {
        "id": "ca-qc-chum-centre-reproduction-image-3",
        "url": "https://www.chumontreal.qc.ca/sites/default/files/styles/square_1_1_mobile/public/2024-06/objective-de-soins_entete.jpg?itok=Hsf_Hx2w",
        "name": "Réfléchir à mes objectifs de soins"
      },
      {
        "id": "ca-qc-chum-centre-reproduction-image-4",
        "url": "https://www.chumontreal.qc.ca/sites/default/files/styles/square_1_1_mobile/public/2025-10/patients-partenaires-web-2600x1300.jpg?itok=dMH91Nnt",
        "name": "Patient·es partenaires"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Hospital-based",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.chumontreal.qc.ca/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Le Centre hospitalier de l'Université de Montréal (CHUM) est un hôpital innovant au service de la population.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-nb-conceptia-clinic",
    "name": "Conceptia Clinic",
    "address": {
      "id": "addr-ca-nb-conceptia-clinic",
      "address1": "35 Providence Street",
      "address2": "Pavillon Hôtel-Dieu Pavilion",
      "city": "Moncton",
      "state": "NB",
      "postalCode": "E1C 8X3",
      "country": "CA"
    },
    "headline": "Conceptia Clinic",
    "images": [
      {
        "id": "ca-nb-conceptia-clinic-image-1",
        "url": "https://cdn.conceptia.ca/attachments/cm06vqe4j5d309ob2d2pwfym4-conceptia-home-team.xl.png",
        "name": "CTA Section Background Image z-1 w-full h-full bg-conceptia-sky-60"
      },
      {
        "id": "ca-nb-conceptia-clinic-image-2",
        "url": "https://cdn.conceptia.ca/attachments/clckscxob01448jgf4a8p3vfa-batch01-img42-ref-1425199.xl.jpg",
        "name": "Slide Link Image relative z-1 aspect-square w-full object-cover"
      },
      {
        "id": "ca-nb-conceptia-clinic-image-3",
        "url": "https://cdn.conceptia.ca/attachments/pc27gjkb8of9lyh202ftyo4a-clinique-conceptia-inc-1.xs.png",
        "name": "Image m-auto max-w-screen-3xs"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.conceptia.ca/",
    "email": null,
    "phone": "506-862-4217",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Moncton's premier fertility clinic, Conceptia, offers a full spectrum of fertility services including IVF and IUI. Explore your journey to parenthood and find out how to schedule your appointment today.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-create-toronto",
    "name": "CReATe",
    "address": {
      "id": "addr-ca-on-create-toronto",
      "address1": "790 Bay Street",
      "address2": "Suite 1100, Toronto, ON M5G 1N8",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "CReATe",
    "images": [
      {
        "id": "ca-on-create-toronto-image-1",
        "url": "https://www.createivf.com/img/banner/screenshot-1200x630.jpg",
        "name": "CReATe"
      },
      {
        "id": "ca-on-create-toronto-image-2",
        "url": "https://www.createivf.com/img/about/clifford-librach.jpg",
        "name": "Dr. Clifford Librach - Reproductive Endocrinologist/Fertility Specialist in Ontario, CReATe Fertility Centre Dr. Clifford Librach - Reproductive Endocrinologist/Fertility Specialist in Ontario, CReATe Fertility Centre rounded-circle"
      },
      {
        "id": "ca-on-create-toronto-image-3",
        "url": "https://www.createivf.com/img/about/karen-glass.jpg",
        "name": "Dr. Karen B. Glass — Gynecologist & IVF Specialist in Toronto, CReATe Fertility Centre Dr. Karen B. Glass — Gynecologist & IVF Specialist in Toronto, CReATe Fertility Centre rounded-circle"
      },
      {
        "id": "ca-on-create-toronto-image-4",
        "url": "https://www.createivf.com/img/about/ari-baratz.jpg",
        "name": "Dr. Ari Y. Baratz - Infertility Treatment Specialist in Toronto, Ontario, CReATe Fertility Centre Dr. Ari Y. Baratz - Infertility Treatment Specialist in Toronto, Ontario, CReATe Fertility Centre rounded-circle"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.createivf.com/",
    "email": null,
    "phone": "4163237727",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "CReATe Fertility Centre is a leading IVF, IUI, Infertility Treatment Clinic based in Toronto, Ontario. It has highly skilled fertility doctors & a high IVF success rate.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "18:00"
      },
      "tue": {
        "open": "07:00",
        "close": "18:00"
      },
      "wed": {
        "open": "07:00",
        "close": "18:00"
      },
      "thu": {
        "open": "07:00",
        "close": "18:00"
      },
      "fri": {
        "open": "07:00",
        "close": "18:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-create-durham-fertility-centre-oshawa",
    "name": "Create Durham Fertility Centre",
    "address": {
      "id": "addr-ca-on-create-durham-fertility-centre-oshawa",
      "address1": "117 King Street East",
      "address2": "Oshawa, ON L1H 1B9",
      "city": "Oshawa",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Create Durham Fertility Centre",
    "images": [
      {
        "id": "ca-on-create-durham-fertility-centre-oshawa-image-1",
        "url": "https://www.createivf.com/img/banner/screenshot-1200x630.jpg",
        "name": "Create Durham Fertility Centre"
      },
      {
        "id": "ca-on-create-durham-fertility-centre-oshawa-image-2",
        "url": "https://www.createivf.com/img/about/clifford-librach.jpg",
        "name": "Dr. Clifford Librach - Reproductive Endocrinologist/Fertility Specialist in Ontario, CReATe Fertility Centre Dr. Clifford Librach - Reproductive Endocrinologist/Fertility Specialist in Ontario, CReATe Fertility Centre rounded-circle"
      },
      {
        "id": "ca-on-create-durham-fertility-centre-oshawa-image-3",
        "url": "https://www.createivf.com/img/about/karen-glass.jpg",
        "name": "Dr. Karen B. Glass — Gynecologist & IVF Specialist in Toronto, CReATe Fertility Centre Dr. Karen B. Glass — Gynecologist & IVF Specialist in Toronto, CReATe Fertility Centre rounded-circle"
      },
      {
        "id": "ca-on-create-durham-fertility-centre-oshawa-image-4",
        "url": "https://www.createivf.com/img/about/ari-baratz.jpg",
        "name": "Dr. Ari Y. Baratz - Infertility Treatment Specialist in Toronto, Ontario, CReATe Fertility Centre Dr. Ari Y. Baratz - Infertility Treatment Specialist in Toronto, Ontario, CReATe Fertility Centre rounded-circle"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://www.createivf.com/",
    "email": null,
    "phone": "9057213582",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "CReATe Fertility Centre is a leading IVF, IUI, Infertility Treatment Clinic based in Toronto, Ontario. It has highly skilled fertility doctors & a high IVF success rate.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "18:00"
      },
      "tue": {
        "open": "07:00",
        "close": "18:00"
      },
      "wed": {
        "open": "07:00",
        "close": "18:00"
      },
      "thu": {
        "open": "07:00",
        "close": "18:00"
      },
      "fri": {
        "open": "07:00",
        "close": "18:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-create-fertility-centre-north-york-north-york",
    "name": "Create Fertility Centre North York",
    "address": {
      "id": "addr-ca-on-create-fertility-centre-north-york-north-york",
      "address1": "4025 Yonge Street",
      "address2": "Suite 215, North York, ON M2P 2E3",
      "city": "North York",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Create Fertility Centre North York",
    "images": [
      {
        "id": "ca-on-create-fertility-centre-north-york-north-york-image-1",
        "url": "https://www.createivf.com/img/banner/screenshot-1200x630.jpg",
        "name": "Create Fertility Centre North York"
      },
      {
        "id": "ca-on-create-fertility-centre-north-york-north-york-image-2",
        "url": "https://www.createivf.com/img/about/clifford-librach.jpg",
        "name": "Dr. Clifford Librach - Reproductive Endocrinologist/Fertility Specialist in Ontario, CReATe Fertility Centre Dr. Clifford Librach - Reproductive Endocrinologist/Fertility Specialist in Ontario, CReATe Fertility Centre rounded-circle"
      },
      {
        "id": "ca-on-create-fertility-centre-north-york-north-york-image-3",
        "url": "https://www.createivf.com/img/about/karen-glass.jpg",
        "name": "Dr. Karen B. Glass — Gynecologist & IVF Specialist in Toronto, CReATe Fertility Centre Dr. Karen B. Glass — Gynecologist & IVF Specialist in Toronto, CReATe Fertility Centre rounded-circle"
      },
      {
        "id": "ca-on-create-fertility-centre-north-york-north-york-image-4",
        "url": "https://www.createivf.com/img/about/ari-baratz.jpg",
        "name": "Dr. Ari Y. Baratz - Infertility Treatment Specialist in Toronto, Ontario, CReATe Fertility Centre Dr. Ari Y. Baratz - Infertility Treatment Specialist in Toronto, Ontario, CReATe Fertility Centre rounded-circle"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://www.createivf.com/",
    "email": null,
    "phone": "4162835539",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "CReATe Fertility Centre is a leading IVF, IUI, Infertility Treatment Clinic based in Toronto, Ontario. It has highly skilled fertility doctors & a high IVF success rate.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "18:00"
      },
      "tue": {
        "open": "07:00",
        "close": "18:00"
      },
      "wed": {
        "open": "07:00",
        "close": "18:00"
      },
      "thu": {
        "open": "07:00",
        "close": "18:00"
      },
      "fri": {
        "open": "07:00",
        "close": "18:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-create-west-fertility-inc-etobicoke",
    "name": "Create West Fertility Inc.",
    "address": {
      "id": "addr-ca-on-create-west-fertility-inc-etobicoke",
      "address1": "56 Aberfoyle Crescent",
      "address2": "Suite 100, Etobicoke, ON M8X 2W4",
      "city": "Etobicoke",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Create West Fertility Inc.",
    "images": [
      {
        "id": "ca-on-create-west-fertility-inc-etobicoke-image-1",
        "url": "https://www.createwestfertility.com/img/banner/screenshot-1200x630.jpg",
        "name": "Create West Fertility Inc."
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.createwestfertility.com",
    "email": null,
    "phone": "4162314100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "CReATe West Fertility is a leading IVF, IUI, Infertility Treatment Clinic based in Etobicoke, Ontario. It has highly skilled fertility doctors & a high IVF success rate.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "06:30",
        "close": "14:30"
      },
      "tue": {
        "open": "06:30",
        "close": "14:30"
      },
      "wed": {
        "open": "06:30",
        "close": "14:30"
      },
      "thu": {
        "open": "06:30",
        "close": "14:30"
      },
      "fri": {
        "open": "06:30",
        "close": "14:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-dr-anthony-auyeung-toronto",
    "name": "Dr. Anthony Auyeung",
    "address": {
      "id": "addr-ca-on-dr-anthony-auyeung-toronto",
      "address1": "180 Bloor Street West, Suite 201",
      "address2": "Toronto, ON M5S 2V6",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Dr. Anthony Auyeung",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": null,
    "email": null,
    "phone": "4162602004",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-on-dr-rahal-fertility-clinic-windsor",
    "name": "Dr. Rahal Fertility Clinic",
    "address": {
      "id": "addr-ca-on-dr-rahal-fertility-clinic-windsor",
      "address1": "8100 Twin Oaks Drive",
      "address2": "Windsor, ON N8N 5C2",
      "city": "Windsor",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Dr. Rahal Fertility Clinic",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": null,
    "email": null,
    "phone": "5199446400",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-on-dream-fertility-whitby",
    "name": "DREAM Fertility",
    "address": {
      "id": "addr-ca-on-dream-fertility-whitby",
      "address1": "198 Des Newman Boulevard",
      "address2": "Whitby, ON L1P 0P9",
      "city": "Whitby",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "DREAM Fertility",
    "images": [
      {
        "id": "ca-on-dream-fertility-whitby-image-1",
        "url": "https://static.wixstatic.com/media/738d7a_27feada9471e44e5aca627f7fefb1d0d~mv2.jpg/v1/fill/w_91,h_61,al_c,q_80,usm_0.66_1.00_0.01,blur_2,enc_avif,quality_auto/738d7a_27feada9471e44e5aca627f7fefb1d0d~mv2.jpg",
        "name": "omar-lopez--25Yf5DvSKs-unsplash.jpg"
      },
      {
        "id": "ca-on-dream-fertility-whitby-image-2",
        "url": "https://static.wixstatic.com/media/738d7a_928c3c2264114a20bbd9aa9370de97a3~mv2.png/v1/fill/w_200,h_199,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Untitled-1.png",
        "name": "Untitled-1.png sh3KLT sFiSiq"
      },
      {
        "id": "ca-on-dream-fertility-whitby-image-3",
        "url": "https://static.wixstatic.com/media/738d7a_a831daa60f9046af8c3bb4e65a4e77f6~mv2.png/v1/fill/w_201,h_201,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Untitled-2.png",
        "name": "Untitled-2.png sh3KLT sFiSiq"
      },
      {
        "id": "ca-on-dream-fertility-whitby-image-4",
        "url": "https://static.wixstatic.com/media/01c3aff52f2a4dffa526d7a9843d46ea.png/v1/fill/w_39,h_39,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/01c3aff52f2a4dffa526d7a9843d46ea.png",
        "name": "Instagram ZK9snE sFiSiq"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.dreamfertility.ca",
    "email": null,
    "phone": "9057212161",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Dream Fertility provides personalized and comprehensive care for those looking to build their family or preserve their fertility. We are Durham regions first and only female led Fertility clinic and proud to offer full service care including access to IVF. We want to help bring your dreams to life.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-etobicoke-fertility-centre-etobicoke",
    "name": "Etobicoke Fertility Centre",
    "address": {
      "id": "addr-ca-on-etobicoke-fertility-centre-etobicoke",
      "address1": "110 Queen's Plate Drive",
      "address2": "Etobicoke, ON M9W 0B4",
      "city": "Etobicoke",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Etobicoke Fertility Centre",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": null,
    "email": null,
    "phone": "4167419900",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-ab-fertilitycare-calgary",
    "name": "FertilityCare Calgary",
    "address": {
      "id": "addr-ca-ab-fertilitycare-calgary",
      "address1": "728 Northmount Drive NW",
      "address2": null,
      "city": "Calgary",
      "state": "AB",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "FertilityCare Calgary",
    "images": [
      {
        "id": "ca-ab-fertilitycare-calgary-image-1",
        "url": "https://i0.wp.com/fertilitycarecanada.com/wp-content/uploads/2021/02/PDF-Small.png?resize=26%2C26&ssl=1",
        "name": "FertilityCare Calgary"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://www.fertilitycarecanada.com/",
    "email": null,
    "phone": "587-288-4255",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Calgary based fertility clinic that specializes in reproductive restoration to help with pregnancy, Infertility, Endometriosis, Pelvic Pain, Polycystic Ovarian Disease, Miscarriage, Post Partum Depression, and PMS",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-qc-fertilys-laval",
    "name": "Fertilys",
    "address": {
      "id": "addr-ca-qc-fertilys-laval",
      "address1": "",
      "address2": null,
      "city": "Laval",
      "state": "QC",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Fertilys",
    "images": [
      {
        "id": "ca-qc-fertilys-laval-image-1",
        "url": "https://www.fertilys.org/wp-content/uploads/2022/12/Debbie_Montjean_Embryologiste_directrice_laboratoire.png",
        "name": "Debbie Montjean"
      },
      {
        "id": "ca-qc-fertilys-laval-image-2",
        "url": "https://www.fertilys.org/wp-content/themes/fertilys/images/metas/meta_fertilys.png",
        "name": "Fertilys"
      },
      {
        "id": "ca-qc-fertilys-laval-image-3",
        "url": "https://www.fertilys.org/wp-content/uploads/2018/11/fertilys_clinique_fertilite_Fecondation_in_vitro_insemination_artificielle_test_grossesse-1684x570.jpg",
        "name": "fertilys clinique fertilite Fecondation in vitro insemination artificielle test grossesse attachment-service size-service"
      },
      {
        "id": "ca-qc-fertilys-laval-image-4",
        "url": "https://www.fertilys.org/wp-content/uploads/2024/03/Camapgne.png",
        "name": "Fertilys"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.fertilys.org/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Fertilys est une clinique de fertilité de Laval favorisant une approche humaine grâce à un service de qualité et une équipe de professionnels de la santé passionnés.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-on-generation-fertility-toronto-west-toronto",
    "name": "Generation Fertility Toronto West",
    "address": {
      "id": "addr-ca-on-generation-fertility-toronto-west-toronto",
      "address1": "56 Aberfoyle Crescent",
      "address2": "Suite 300, Toronto, ON M8X 2W4",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Generation Fertility Toronto West",
    "images": [
      {
        "id": "ca-on-generation-fertility-toronto-west-toronto-image-1",
        "url": "https://newcdn.generationfertility.ca/attachments/mkrrn6lor1l9jd1gg6tbe8sh-ckvy5eqwk030br31g7bi0z6l0-tfp-blog-header-dr-gurau-max.full.jpg",
        "name": "Generation Fertility specialist consulting with a patient while taking notes on a clipboard in a warmly lit medical office. aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-toronto-west-toronto-image-2",
        "url": "https://www.generationfertility.ca/images/team.jpg",
        "name": "decoration w-full"
      },
      {
        "id": "ca-on-generation-fertility-toronto-west-toronto-image-3",
        "url": "https://newcdn.generationfertility.ca/attachments/imqf7y5bt2lybk8vemwmazw2-ckpzlw6ne00mkikh4dyntxn1w-hero-image-0005-layer-1-full.full.jpg",
        "name": "aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-toronto-west-toronto-image-4",
        "url": "https://newcdn.generationfertility.ca/attachments/vlvawoybhcl03zu28ul3p7i1-leaf-ex.full.webp",
        "name": "Close-up of healthy green leaf {"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.generationfertility.ca/",
    "email": null,
    "phone": "4162338111",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Generation Fertility offers expert fertility doctors and advanced IVF treatments in Toronto, Vaughan, Newmarket, and Waterloo. Start your care today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "06:30",
        "close": "14:30"
      },
      "tue": {
        "open": "06:30",
        "close": "14:30"
      },
      "wed": {
        "open": "06:30",
        "close": "14:30"
      },
      "thu": {
        "open": "06:30",
        "close": "14:30"
      },
      "fri": {
        "open": "06:30",
        "close": "14:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-generation-fertility-waterloo-waterloo",
    "name": "Generation Fertility Waterloo",
    "address": {
      "id": "addr-ca-on-generation-fertility-waterloo-waterloo",
      "address1": "435 The Boardwalk, Suite 508",
      "address2": "Waterloo, ON N2T 0C2",
      "city": "Waterloo",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Generation Fertility Waterloo",
    "images": [
      {
        "id": "ca-on-generation-fertility-waterloo-waterloo-image-1",
        "url": "https://newcdn.generationfertility.ca/attachments/mkrrn6lor1l9jd1gg6tbe8sh-ckvy5eqwk030br31g7bi0z6l0-tfp-blog-header-dr-gurau-max.full.jpg",
        "name": "Generation Fertility specialist consulting with a patient while taking notes on a clipboard in a warmly lit medical office. aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-waterloo-waterloo-image-2",
        "url": "https://www.generationfertility.ca/images/team.jpg",
        "name": "decoration w-full"
      },
      {
        "id": "ca-on-generation-fertility-waterloo-waterloo-image-3",
        "url": "https://newcdn.generationfertility.ca/attachments/imqf7y5bt2lybk8vemwmazw2-ckpzlw6ne00mkikh4dyntxn1w-hero-image-0005-layer-1-full.full.jpg",
        "name": "aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-waterloo-waterloo-image-4",
        "url": "https://newcdn.generationfertility.ca/attachments/vlvawoybhcl03zu28ul3p7i1-leaf-ex.full.webp",
        "name": "Close-up of healthy green leaf {"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.generationfertility.ca/the-generation-difference/generation-fertility-waterloo",
    "email": null,
    "phone": "5195700090",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Generation Fertility offers expert fertility doctors and advanced IVF treatments in Toronto, Vaughan, Newmarket, and Waterloo. Start your care today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "06:30",
        "close": "14:30"
      },
      "tue": {
        "open": "06:30",
        "close": "14:30"
      },
      "wed": {
        "open": "06:30",
        "close": "14:30"
      },
      "thu": {
        "open": "06:30",
        "close": "14:30"
      },
      "fri": {
        "open": "06:30",
        "close": "14:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-generation-fertility-newmarket-newmarket",
    "name": "Generation Fertility, Newmarket",
    "address": {
      "id": "addr-ca-on-generation-fertility-newmarket-newmarket",
      "address1": "1111 Davis Drive East",
      "address2": "Unit 39, Newmarket, ON L3Y 9E5",
      "city": "Newmarket",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Generation Fertility, Newmarket",
    "images": [
      {
        "id": "ca-on-generation-fertility-newmarket-newmarket-image-1",
        "url": "https://newcdn.generationfertility.ca/attachments/mkrrn6lor1l9jd1gg6tbe8sh-ckvy5eqwk030br31g7bi0z6l0-tfp-blog-header-dr-gurau-max.full.jpg",
        "name": "Generation Fertility specialist consulting with a patient while taking notes on a clipboard in a warmly lit medical office. aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-newmarket-newmarket-image-2",
        "url": "https://www.generationfertility.ca/images/team.jpg",
        "name": "decoration w-full"
      },
      {
        "id": "ca-on-generation-fertility-newmarket-newmarket-image-3",
        "url": "https://newcdn.generationfertility.ca/attachments/imqf7y5bt2lybk8vemwmazw2-ckpzlw6ne00mkikh4dyntxn1w-hero-image-0005-layer-1-full.full.jpg",
        "name": "aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-newmarket-newmarket-image-4",
        "url": "https://newcdn.generationfertility.ca/attachments/vlvawoybhcl03zu28ul3p7i1-leaf-ex.full.webp",
        "name": "Close-up of healthy green leaf {"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.generationfertility.ca/",
    "email": null,
    "phone": "9059670852",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Generation Fertility offers expert fertility doctors and advanced IVF treatments in Toronto, Vaughan, Newmarket, and Waterloo. Start your care today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "06:30",
        "close": "14:30"
      },
      "tue": {
        "open": "06:30",
        "close": "14:30"
      },
      "wed": {
        "open": "06:30",
        "close": "14:30"
      },
      "thu": {
        "open": "06:30",
        "close": "14:30"
      },
      "fri": {
        "open": "06:30",
        "close": "14:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-generation-fertility-vaughan-vaughan",
    "name": "Generation Fertility, Vaughan",
    "address": {
      "id": "addr-ca-on-generation-fertility-vaughan-vaughan",
      "address1": "955 Major Mackenzie Drive West",
      "address2": "Suite 400, Vaughan, ON L6A 4P9",
      "city": "Vaughan",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Generation Fertility, Vaughan",
    "images": [
      {
        "id": "ca-on-generation-fertility-vaughan-vaughan-image-1",
        "url": "https://newcdn.generationfertility.ca/attachments/mkrrn6lor1l9jd1gg6tbe8sh-ckvy5eqwk030br31g7bi0z6l0-tfp-blog-header-dr-gurau-max.full.jpg",
        "name": "Generation Fertility specialist consulting with a patient while taking notes on a clipboard in a warmly lit medical office. aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-vaughan-vaughan-image-2",
        "url": "https://www.generationfertility.ca/images/team.jpg",
        "name": "decoration w-full"
      },
      {
        "id": "ca-on-generation-fertility-vaughan-vaughan-image-3",
        "url": "https://newcdn.generationfertility.ca/attachments/imqf7y5bt2lybk8vemwmazw2-ckpzlw6ne00mkikh4dyntxn1w-hero-image-0005-layer-1-full.full.jpg",
        "name": "aspect-square object-cover"
      },
      {
        "id": "ca-on-generation-fertility-vaughan-vaughan-image-4",
        "url": "https://newcdn.generationfertility.ca/attachments/vlvawoybhcl03zu28ul3p7i1-leaf-ex.full.webp",
        "name": "Close-up of healthy green leaf {"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.generationfertility.ca",
    "email": null,
    "phone": "2893570100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Generation Fertility offers expert fertility doctors and advanced IVF treatments in Toronto, Vaughan, Newmarket, and Waterloo. Start your care today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "06:30",
        "close": "14:30"
      },
      "tue": {
        "open": "06:30",
        "close": "14:30"
      },
      "wed": {
        "open": "06:30",
        "close": "14:30"
      },
      "thu": {
        "open": "06:30",
        "close": "14:30"
      },
      "fri": {
        "open": "06:30",
        "close": "14:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-bc-genesis-fertility-centre",
    "name": "Genesis Fertility Centre",
    "address": {
      "id": "addr-ca-bc-genesis-fertility-centre",
      "address1": "1367 West Broadway",
      "address2": "Suite 300",
      "city": "Vancouver",
      "state": "BC",
      "postalCode": "V6H 4A7",
      "country": "CA"
    },
    "headline": "Genesis Fertility Centre",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://genesis-fertility.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-bc-grace-fertility-centre",
    "name": "Grace Fertility Centre",
    "address": {
      "id": "addr-ca-bc-grace-fertility-centre",
      "address1": "604 West Broadway",
      "address2": "Suite 210",
      "city": "Vancouver",
      "state": "BC",
      "postalCode": "V5Z 1G1",
      "country": "CA"
    },
    "headline": "Grace Fertility Centre",
    "images": [
      {
        "id": "ca-bc-grace-fertility-centre-image-1",
        "url": "https://cdn.fertilitywithgrace.com/attachments/clospjjf801r2z9py9djfhbe5-untitled-design-2023-11-10t092237-154.lg.jpg",
        "name": "Dr. Anthony Cheung from Grace Fertility clinic in Vancouver w-full h-full object-cover object-center transform group-hover:scale-110 transition-transform duration-200 ease-out-quad"
      },
      {
        "id": "ca-bc-grace-fertility-centre-image-2",
        "url": "https://cdn.fertilitywithgrace.com/attachments/clggioa5s011r6qh4c735cky6-adobestock-486604138.xl.jpg",
        "name": "CTA Section Background Image w-full h-full object-cover"
      },
      {
        "id": "ca-bc-grace-fertility-centre-image-3",
        "url": "https://cdn.fertilitywithgrace.com/attachments/clggiq509013l6qh4hc513t0u-batch01-img18-ref-1804932427.md.jpg",
        "name": "Image Link List Image w-full h-full object-cover object-center"
      },
      {
        "id": "ca-bc-grace-fertility-centre-image-4",
        "url": "https://cdn.fertilitywithgrace.com/attachments/clggio0ip011k6qh48t67004t-adobestock-162581046.md.jpg",
        "name": "Image Link List Image w-full h-full object-cover object-center"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.fertilitywithgrace.com/",
    "email": null,
    "phone": "604-558-4886",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Discover compassionate care with our Vancouver fertility specialists. Grace Fertility offers personalized treatments to help you start your family journey.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:30"
      },
      "tue": {
        "open": "08:00",
        "close": "16:30"
      },
      "wed": {
        "open": "08:00",
        "close": "16:30"
      },
      "thu": {
        "open": "08:00",
        "close": "16:30"
      },
      "fri": {
        "open": "08:00",
        "close": "16:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-halton-fertility-and-women-s-health-centre-oakville",
    "name": "Halton Fertility and Women’s Health Centre",
    "address": {
      "id": "addr-ca-on-halton-fertility-and-women-s-health-centre-oakville",
      "address1": "1075 North Service Road West",
      "address2": "Unit 25-29, Oakville, ON L6M 2G2",
      "city": "Oakville",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Halton Fertility and Women’s Health Centre",
    "images": [
      {
        "id": "ca-on-halton-fertility-and-women-s-health-centre-oakville-image-1",
        "url": "https://www.haltonfertility.com/images/home/about-img.jpg",
        "name": "Baby"
      },
      {
        "id": "ca-on-halton-fertility-and-women-s-health-centre-oakville-image-2",
        "url": "https://www.haltonfertility.com/images/home/bg-img-1.jpg",
        "name": "Halton Fertility and Women’s Health Centre"
      },
      {
        "id": "ca-on-halton-fertility-and-women-s-health-centre-oakville-image-3",
        "url": "https://www.haltonfertility.com/images/home/bg-img-2.jpg",
        "name": "Halton Fertility and Women’s Health Centre"
      },
      {
        "id": "ca-on-halton-fertility-and-women-s-health-centre-oakville-image-4",
        "url": "https://www.haltonfertility.com/images/home/bg-img-3.jpg",
        "name": "Halton Fertility and Women’s Health Centre"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.haltonfertility.com",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Halton Fertility & Women’s Health Centre is the area’s premier fertility clinic committed to helping you realize your conception goals. It is our pleasure to assist in giving one of the greatest gifts life has to offer - having a child of your own. We offer our patients specialized and personal care in reproductive endocrinology and infertility.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-hannam-fertility-centre-toronto",
    "name": "Hannam Fertility Centre",
    "address": {
      "id": "addr-ca-on-hannam-fertility-centre-toronto",
      "address1": "160 Bloor Street East",
      "address2": "Suite 1500, Toronto, ON M4W 3R2",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Hannam Fertility Centre",
    "images": [
      {
        "id": "ca-on-hannam-fertility-centre-toronto-image-1",
        "url": "https://images.squarespace-cdn.com/content/v1/67055e02dc64a07d6352a1d3/9d95519f-fe7d-4b5b-9bcf-5d2b8eceedea/fertility-preservation-hannam%402x.webp",
        "name": "Young woman learning more about fertility preservation or egg freezing at a top fertility clinic in Toronto, Hannam Fertility Centre"
      },
      {
        "id": "ca-on-hannam-fertility-centre-toronto-image-2",
        "url": "https://images.squarespace-cdn.com/content/v1/67055e02dc64a07d6352a1d3/015c9e2b-8149-4a13-8326-1f73e2507855/Colour_1.webp?format=1500w",
        "name": "Hannam Fertility Centre | Top Fertility Clinic Toronto - IVF, IUI, Egg Freezing"
      },
      {
        "id": "ca-on-hannam-fertility-centre-toronto-image-3",
        "url": "https://images.squarespace-cdn.com/content/v1/67055e02dc64a07d6352a1d3/2a5b728b-8b58-4d3a-8333-53e5eba0eff9/check-fertility%403x.webp",
        "name": "A young woman and man sitting on a bed looking at a laptop, each holding a mug, in a casual home setting researching Hannam Fertility Centre, top fertility clinic in Toronto"
      },
      {
        "id": "ca-on-hannam-fertility-centre-toronto-image-4",
        "url": "https://images.squarespace-cdn.com/content/v1/67055e02dc64a07d6352a1d3/a9ce5673-b5b2-4cf6-8861-a04508b1f433/ttc-hannam%402x.webp",
        "name": "Hannam fertility clinic Toronto - lesbian couple trying to conceive and seeking IVF in Toronto"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://hannamfertility.com/",
    "email": null,
    "phone": "4165951521",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Hannam Fertility Centre is a leading fertility clinic in Toronto, providing compassionate, cutting-edge precision fertility care for individuals and couples. Specializing in IVF, IUI, fertility preservation (egg freezing), natural conception support and genetic testing. Our expert team is supported by a world-class CCRM fertility lab that help patients achieve their family goals with high success.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-harmony-fertility-concord",
    "name": "Harmony Fertility",
    "address": {
      "id": "addr-ca-on-harmony-fertility-concord",
      "address1": "1600 Steeles Avenue West",
      "address2": "Suite 25, Concord, ON L4K 2M2",
      "city": "Concord",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Harmony Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://harmonywomensclinic.com/",
    "email": null,
    "phone": "9058846119",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-mb-heartland-fertility",
    "name": "Heartland Fertility & Gynecology Clinic",
    "address": {
      "id": "addr-ca-mb-heartland-fertility",
      "address1": "1661 Portage Avenue",
      "address2": "Suite 701",
      "city": "Winnipeg",
      "state": "MB",
      "postalCode": "R3J 3T7",
      "country": "CA"
    },
    "headline": "Heartland Fertility & Gynecology Clinic",
    "images": [
      {
        "id": "ca-mb-heartland-fertility-image-1",
        "url": "https://cdn.heartlandfertility.mb.ca/attachments/kqbykmo2qsjrt37z180bsfdm-screenshot-2025-11-25-at-11-32-42.max.png",
        "name": "Heartland Fertility & Gynecology Clinic"
      },
      {
        "id": "ca-mb-heartland-fertility-image-2",
        "url": "https://cdn.heartlandfertility.mb.ca/attachments/cl6gq7xvc000vv9h46awecmw7-adobestock-489813484.xl.jpg",
        "name": "Column Hero Right Container Image relative w-full h-full object-cover"
      },
      {
        "id": "ca-mb-heartland-fertility-image-3",
        "url": "https://cdn.heartlandfertility.mb.ca/attachments/cl7ykwxjw01zui2h443wzgmox-batch01-img18-ref-1804932427.md.jpg",
        "name": "Slider Slide Link Background Image relative aspect-square z-0 w-full h-full object-cover opacity-50 group-hover:opacity-100 grayscale group-hover:grayscale-0 transition duration-200 ease-linear"
      },
      {
        "id": "ca-mb-heartland-fertility-image-4",
        "url": "https://cdn.heartlandfertility.mb.ca/attachments/cl6dr4h4y00ltmmh44uhk5yaf-adobestock-380439522.md.jpg",
        "name": "Slider Slide Link Background Image relative aspect-square z-0 w-full h-full object-cover opacity-50 group-hover:opacity-100 grayscale group-hover:grayscale-0 transition duration-200 ease-linear"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.heartlandfertility.mb.ca/",
    "email": null,
    "phone": "204-779-8888",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Heartland is the leading fertility clinic in the heart of Manitoba, Winnipeg, offering personalized treatments to help you start your family journey.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:30"
      },
      "tue": {
        "open": "08:00",
        "close": "16:30"
      },
      "wed": {
        "open": "08:00",
        "close": "16:30"
      },
      "thu": {
        "open": "08:00",
        "close": "16:30"
      },
      "fri": {
        "open": "08:00",
        "close": "16:30"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-hope-fertility-and-reproductive-medicine-centre-scarborough",
    "name": "Hope Fertility and Reproductive Medicine Centre",
    "address": {
      "id": "addr-ca-on-hope-fertility-and-reproductive-medicine-centre-scarborough",
      "address1": "2330 Kennedy Road",
      "address2": "Suite 317, Scarborough, ON M1T 0A2",
      "city": "Scarborough",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Hope Fertility and Reproductive Medicine Centre",
    "images": [
      {
        "id": "ca-on-hope-fertility-and-reproductive-medicine-centre-scarborough-image-1",
        "url": "https://old.hopefertility.ca/wp-content/uploads/2024/04/NROTH2023.jpg",
        "name": "wp-image-1281 alignleft"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://hopefertility.ca/",
    "email": null,
    "phone": "4166098868",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "[fusion_builder_container background_color=\"\" background_image=\"http://newhope2.zarumedia.com/wp-content/uploads/2016/01/header-image-about.jpg\" background_parallax=\"down\" enable_mobile=\"no\" parallax_speed=\"0.4\" background_repeat=\"no-repeat\" background_position=\"center top\" video_url=\"\" video_aspect_ratio=\"16:9\" video_webm=\"\" video_mp4=\"\" video_ogv=\"\" video_preview_image=\"\" overlay_color=\"\" video_mute=\"yes\" video_loop=\"yes\" fade=\"no\" border_size=\"0px\" border_color=\"\" border_style=\"solid\" padding_top=\"10%\" padding_bottom=\"10%\" padding_left=\"5%\" padding_right=\"5%\" hundred_percent=\"no\" equal_height_columns=\"no\" hide_on_mobile=\"no\" menu_anchor=\"\" class=\"\" id=\"\"][fusion_builder_column type=\"1_1\" layout=\"1_1\" last=\"yes\" spacing=\"yes\" center_content=\"no\" hide_on_mobile=\"no\" background_color=\"\" background_image=\"\" background_repeat=\"no-repeat\" background_position=\"left top\" hover_type=\"none\" link=\"\" border_position=\"all\" border_size=\"0px\" border_color=\"\" border_style=\"\" padding_top=\"\" padding_right=\"\" padding_bottom=\"\" padding_left=\"\" margin_top=\"\" margin_bottom=\"\"",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-horizon-fertility-orillia",
    "name": "Horizon Fertility",
    "address": {
      "id": "addr-ca-on-horizon-fertility-orillia",
      "address1": "16 O’Brien Street, Suite 103",
      "address2": "Orillia, ON L3V 5S2",
      "city": "Orillia",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Horizon Fertility",
    "images": [
      {
        "id": "ca-on-horizon-fertility-orillia-image-1",
        "url": "https://images.squarespace-cdn.com/content/v1/6671bff7f8af0356d167bb65/e43ae500-d050-455b-9f75-becdd39f3688/output-onlinepngtools.png?format=1500w",
        "name": "Horizon Fertility"
      },
      {
        "id": "ca-on-horizon-fertility-orillia-image-2",
        "url": "https://images.squarespace-cdn.com/content/v1/6671bff7f8af0356d167bb65/1718730838319-B6DOI55P8H91PIROZZE0/image-asset.jpeg",
        "name": "Horizon Fertility"
      },
      {
        "id": "ca-on-horizon-fertility-orillia-image-3",
        "url": "https://images.squarespace-cdn.com/content/v1/6671bff7f8af0356d167bb65/1718734382735-YP5ECMC2YSJM525U1AB0/image-asset.jpeg",
        "name": "Horizon Fertility"
      },
      {
        "id": "ca-on-horizon-fertility-orillia-image-4",
        "url": "https://images.squarespace-cdn.com/content/v1/6671bff7f8af0356d167bb65/1718734037220-C7A430J85216FZWKBOWO/image-asset.jpeg",
        "name": "Horizon Fertility"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.horizonfertility.ca",
    "email": null,
    "phone": "7055582331",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Fertility Clinic serving Orillia, Muskoka, Parry Sound, Midland and surrounding areas",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-ivf-canada-and-the-life-program-scarborough",
    "name": "IVF Canada & The Life Program",
    "address": {
      "id": "addr-ca-on-ivf-canada-and-the-life-program-scarborough",
      "address1": "2347 Kennedy Road",
      "address2": "Suite 304, Scarborough, ON M1T 3T8",
      "city": "Scarborough",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "IVF Canada & The Life Program",
    "images": [
      {
        "id": "ca-on-ivf-canada-and-the-life-program-scarborough-image-1",
        "url": "https://ivfcanada.com/wp-content/uploads/2022/01/qr-code-img.jpg",
        "name": "IVF Canada & The Life Program"
      },
      {
        "id": "ca-on-ivf-canada-and-the-life-program-scarborough-image-2",
        "url": "https://ivfcanada.com/wp-content/uploads/2025/08/paceholder-cover.png",
        "name": "IVF Canada & The Life Program"
      },
      {
        "id": "ca-on-ivf-canada-and-the-life-program-scarborough-image-3",
        "url": "https://ivfcanada.com/wp-content/uploads/2021/04/start-here-text.png",
        "name": "IVF Canada & The Life Program"
      },
      {
        "id": "ca-on-ivf-canada-and-the-life-program-scarborough-image-4",
        "url": "https://ivfcanada.com/wp-content/uploads/2021/04/history-lady-img.png",
        "name": "Pregnant woman"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.ivfcanada.com/",
    "email": null,
    "phone": "4167541010",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "IVF Canada is a state-of-the-art fertility centre in the Greater Toronto area. Trying to conceive? We can help.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-ivf-canada-markham-markham",
    "name": "IVF Canada Markham",
    "address": {
      "id": "addr-ca-on-ivf-canada-markham-markham",
      "address1": "7191 Yonge Street",
      "address2": "Suite 111 Markham, ON L3T 0C4",
      "city": "Markham",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "IVF Canada Markham",
    "images": [
      {
        "id": "ca-on-ivf-canada-markham-markham-image-1",
        "url": "https://ivfcanada.com/wp-content/uploads/2022/01/qr-code-img.jpg",
        "name": "IVF Canada Markham"
      },
      {
        "id": "ca-on-ivf-canada-markham-markham-image-2",
        "url": "https://ivfcanada.com/wp-content/uploads/2025/08/paceholder-cover.png",
        "name": "IVF Canada Markham"
      },
      {
        "id": "ca-on-ivf-canada-markham-markham-image-3",
        "url": "https://ivfcanada.com/wp-content/uploads/2021/04/start-here-text.png",
        "name": "IVF Canada Markham"
      },
      {
        "id": "ca-on-ivf-canada-markham-markham-image-4",
        "url": "https://ivfcanada.com/wp-content/uploads/2021/04/history-lady-img.png",
        "name": "Pregnant woman"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.ivfcanada.com/",
    "email": null,
    "phone": "9055977661",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "IVF Canada is a state-of-the-art fertility centre in the Greater Toronto area. Trying to conceive? We can help.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-nl-james-paton-memorial-fertility-clinic",
    "name": "James Paton Memorial Fertility Clinic",
    "address": {
      "id": "addr-ca-nl-james-paton-memorial-fertility-clinic",
      "address1": "125 Trans Canada Highway",
      "address2": null,
      "city": "Gander",
      "state": "NL",
      "postalCode": "A1V 1P7",
      "country": "CA"
    },
    "headline": "James Paton Memorial Fertility Clinic",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Hospital-based",
    "conditions": [],
    "treatments": ["IUI"],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-on-lakeridge-fertility-whitby",
    "name": "Lakeridge Fertility",
    "address": {
      "id": "addr-ca-on-lakeridge-fertility-whitby",
      "address1": "220 Dundas Street West",
      "address2": "Suite 404, Whitby, ON L1N 8M7",
      "city": "Whitby",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Lakeridge Fertility",
    "images": [
      {
        "id": "ca-on-lakeridge-fertility-whitby-image-1",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/ofn-doctor-patient.png",
        "name": "ofn-doctor-patient wp-image-2256"
      },
      {
        "id": "ca-on-lakeridge-fertility-whitby-image-2",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/og-image.jpg",
        "name": "Lakeridge Fertility"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://ontariofertilitynetwork.com/locations/lakeridge-fertility-clinic/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Are you trying to conceive or struggling with infertility? Our fertility clinics & specialists in Ontario can help. Book your fertility assessment today.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-markham-fertility-centre-markham",
    "name": "Markham Fertility Centre",
    "address": {
      "id": "addr-ca-on-markham-fertility-centre-markham",
      "address1": "379 Church Street",
      "address2": "5th floor, Markham, ON L6B 0T1",
      "city": "Markham",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Markham Fertility Centre",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://markhamfertility.com/",
    "email": null,
    "phone": "9054727128",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-mcf-reproductive-and-health-services-north-york",
    "name": "MCF Reproductive & Health Services",
    "address": {
      "id": "addr-ca-on-mcf-reproductive-and-health-services-north-york",
      "address1": "2888 Bathurst Street",
      "address2": "Suite 100, North York, ON M6B 4H6",
      "city": "North York",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "MCF Reproductive & Health Services",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://mcfreproductive.com/",
    "email": null,
    "phone": "4162214602",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-qc-muhc-reproductive-centre",
    "name": "McGill University Health Centre Reproductive Centre",
    "address": {
      "id": "addr-ca-qc-muhc-reproductive-centre",
      "address1": "687 Pine Avenue West",
      "address2": "Women's Pavilion, 6th Floor",
      "city": "Montreal",
      "state": "QC",
      "postalCode": "H3A 1A1",
      "country": "CA"
    },
    "headline": "McGill University Health Centre Reproductive Centre",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Hospital-based",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.mcgillivf.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-qc-montreal-fertility-centre",
    "name": "Montreal Fertility Centre",
    "address": {
      "id": "addr-ca-qc-montreal-fertility-centre",
      "address1": "5252 Boulevard de Maisonneuve Ouest",
      "address2": "Suite 220",
      "city": "Montreal",
      "state": "QC",
      "postalCode": "H4A 3S5",
      "country": "CA"
    },
    "headline": "Montreal Fertility Centre",
    "images": [
      {
        "id": "ca-qc-montreal-fertility-centre-image-1",
        "url": "https://www.montrealfertility.com/wp-content/uploads/2019/12/montreal-fertility-center.png",
        "name": "Montreal Fertility Center"
      },
      {
        "id": "ca-qc-montreal-fertility-centre-image-2",
        "url": "https://www.montrealfertility.com/wp-content/uploads/2019/05/centre_fertilite_montreal_garcon-1010x730.jpg",
        "name": "Image"
      },
      {
        "id": "ca-qc-montreal-fertility-centre-image-3",
        "url": "https://www.montrealfertility.com/wp-content/uploads/2019/05/centre_fertilite_montreal_enfant2-1010x730.jpg",
        "name": "Image"
      },
      {
        "id": "ca-qc-montreal-fertility-centre-image-4",
        "url": "https://www.montrealfertility.com/wp-content/uploads/2019/05/centre_fertilite_montreal_fille-1010x730.jpg",
        "name": "Image"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.montrealfertility.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "The Montreal Fertility Centre was founded in 2002 with the intent of providing patients with the highest degree of personalized fertility care in Canada.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-mount-sinai-fertility-toronto",
    "name": "Mount Sinai Fertility",
    "address": {
      "id": "addr-ca-on-mount-sinai-fertility-toronto",
      "address1": "250 Dundas Street West,",
      "address2": "7th Floor, Toronto, ON M5T 2Z5",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Mount Sinai Fertility",
    "images": [
      {
        "id": "ca-on-mount-sinai-fertility-toronto-image-1",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2025/10/ofp-funding-1000x667-1-245x145.jpg",
        "name": "Queen's Park buildings with a blue sky ofp funding 1000x667 vc_single_image-img"
      },
      {
        "id": "ca-on-mount-sinai-fertility-toronto-image-2",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2021/12/nursingteam.jpg",
        "name": "Nursing Team nursingteam vc_single_image-img attachment-full"
      },
      {
        "id": "ca-on-mount-sinai-fertility-toronto-image-3",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2021/12/16123_MSF_Main_Banner.jpg",
        "name": "We Care"
      },
      {
        "id": "ca-on-mount-sinai-fertility-toronto-image-4",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2021/12/MSFert_RGB_300.png",
        "name": "Logo normal"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.mountsinaifertility.com/",
    "email": null,
    "phone": "4165864748",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Mount Sinai Fertility offers advanced reproductive services to help patients with all aspects of fertility.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-mount-sinai-fertility-mississauga-oakville-mississauga",
    "name": "Mount Sinai Fertility (Mississauga-Oakville)",
    "address": {
      "id": "addr-ca-on-mount-sinai-fertility-mississauga-oakville-mississauga",
      "address1": "800 Southdown Road",
      "address2": "Suite A4, Mississauga, ON L5J 2Y4",
      "city": "Mississauga",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Mount Sinai Fertility (Mississauga-Oakville)",
    "images": [
      {
        "id": "ca-on-mount-sinai-fertility-mississauga-oakville-mississauga-image-1",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2025/10/ofp-funding-1000x667-1-245x145.jpg",
        "name": "Queen's Park buildings with a blue sky ofp funding 1000x667 vc_single_image-img"
      },
      {
        "id": "ca-on-mount-sinai-fertility-mississauga-oakville-mississauga-image-2",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2021/12/nursingteam.jpg",
        "name": "Nursing Team nursingteam vc_single_image-img attachment-full"
      },
      {
        "id": "ca-on-mount-sinai-fertility-mississauga-oakville-mississauga-image-3",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2021/12/16123_MSF_Main_Banner.jpg",
        "name": "We Care"
      },
      {
        "id": "ca-on-mount-sinai-fertility-mississauga-oakville-mississauga-image-4",
        "url": "https://mountsinaifertility.com/wp-content/uploads/2021/12/MSFert_RGB_300.png",
        "name": "Logo normal"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://mountsinaifertility.com/",
    "email": null,
    "phone": "9059015123",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Mount Sinai Fertility offers advanced reproductive services to help patients with all aspects of fertility.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-nahal-fertility-program-richmond-hill",
    "name": "Nahal Fertility Program",
    "address": {
      "id": "addr-ca-on-nahal-fertility-program-richmond-hill",
      "address1": "30 Wertheime Court",
      "address2": "Suite 22, Richmond Hill, ON L4B 1B9",
      "city": "Richmond Hill",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Nahal Fertility Program",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://nahalfertility.com/",
    "email": null,
    "phone": "9054823389",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-neo-fertility-services-sudbury",
    "name": "NEO Fertility Services",
    "address": {
      "id": "addr-ca-on-neo-fertility-services-sudbury",
      "address1": "1596 Regent Street",
      "address2": "Sudbury, ON P3E 3Z6",
      "city": "Sudbury",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NEO Fertility Services",
    "images": [
      {
        "id": "ca-on-neo-fertility-services-sudbury-image-1",
        "url": "https://static.wixstatic.com/media/775f33_88e2b2e90afa4620acc4f69edb097de2~mv2_d_2354_1882_s_2.jpg/v1/fill/w_231,h_184,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/775f33_88e2b2e90afa4620acc4f69edb097de2~mv2_d_2354_1882_s_2.jpg",
        "name": "sh3KLT sFiSiq"
      },
      {
        "id": "ca-on-neo-fertility-services-sudbury-image-2",
        "url": "https://static.wixstatic.com/media/775f33_211a7d3341b140fdb9193783cc83a105~mv2.jpg/v1/fill/w_768,h_575,al_c,lg_1,q_85,enc_avif,quality_auto/IMG_2186.jpg",
        "name": "IMG_2186.jpg XBQCDC sFiSiq"
      },
      {
        "id": "ca-on-neo-fertility-services-sudbury-image-3",
        "url": "https://static.wixstatic.com/media/775f33_00d4e0eb21fd4e6a923e7c7253f0d032~mv2.jpg/v1/crop/x_0,y_0,w_377,h_375/fill/w_338,h_334,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/775f33_00d4e0eb21fd4e6a923e7c7253f0d032~mv2.jpg",
        "name": "gRkIq0 sFiSiq"
      },
      {
        "id": "ca-on-neo-fertility-services-sudbury-image-4",
        "url": "https://static.wixstatic.com/media/e316f544f9094143b9eac01f1f19e697.png/v1/fill/w_39,h_39,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/e316f544f9094143b9eac01f1f19e697.png",
        "name": "Facebook Social Icon ZK9snE sFiSiq"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.neowomenshealth.ca",
    "email": null,
    "phone": "7052220492",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "We provide obstetric, gynecologic and fertility services to women in Sudbury and North Eastern Ontario. Please visit us for more information.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-newlife-fertility-centre-mississauga",
    "name": "NewLife Fertility Centre",
    "address": {
      "id": "addr-ca-on-newlife-fertility-centre-mississauga",
      "address1": "4250 Sherwoodtowne Boulevard",
      "address2": "Mississauga, ON L4Z 2G6",
      "city": "Mississauga",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NewLife Fertility Centre",
    "images": [
      {
        "id": "ca-on-newlife-fertility-centre-mississauga-image-1",
        "url": "https://newlifefertility.com/wp-content/uploads/2024/11/Main-Banner.png",
        "name": "NewLife Fertility Centre"
      },
      {
        "id": "ca-on-newlife-fertility-centre-mississauga-image-2",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/07/Nival-scaled.png",
        "name": "attachment-full size-full wp-image-15397"
      },
      {
        "id": "ca-on-newlife-fertility-centre-mississauga-image-3",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design33.png",
        "name": "attachment-large size-large wp-image-13007"
      },
      {
        "id": "ca-on-newlife-fertility-centre-mississauga-image-4",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design31.png",
        "name": "attachment-large size-large wp-image-13005"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://newlifefertility.com/",
    "email": null,
    "phone": "9058967100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "NewLife Fertility Centre is Canada's leading fertility clinic, offering advanced treatments like IVF, egg freezing & IUI with expert care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-newlife-fertility-centre-brampton-brampton",
    "name": "NewLife Fertility Centre, Brampton",
    "address": {
      "id": "addr-ca-on-newlife-fertility-centre-brampton-brampton",
      "address1": "Unit 210, 2 Dewside Drive",
      "address2": "Brampton, ON L6R 3Y5",
      "city": "Brampton",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NewLife Fertility Centre, Brampton",
    "images": [
      {
        "id": "ca-on-newlife-fertility-centre-brampton-brampton-image-1",
        "url": "https://newlifefertility.com/wp-content/uploads/2024/11/Main-Banner.png",
        "name": "NewLife Fertility Centre, Brampton"
      },
      {
        "id": "ca-on-newlife-fertility-centre-brampton-brampton-image-2",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/07/Nival-scaled.png",
        "name": "attachment-full size-full wp-image-15397"
      },
      {
        "id": "ca-on-newlife-fertility-centre-brampton-brampton-image-3",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design33.png",
        "name": "attachment-large size-large wp-image-13007"
      },
      {
        "id": "ca-on-newlife-fertility-centre-brampton-brampton-image-4",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design31.png",
        "name": "attachment-large size-large wp-image-13005"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://newlifefertility.com/",
    "email": null,
    "phone": "9058967100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "NewLife Fertility Centre is Canada's leading fertility clinic, offering advanced treatments like IVF, egg freezing & IUI with expert care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-newlife-fertility-centre-burlington-burlington",
    "name": "NewLife Fertility Centre, Burlington",
    "address": {
      "id": "addr-ca-on-newlife-fertility-centre-burlington-burlington",
      "address1": "418 Plains Road East",
      "address2": "Burlington, ON L7T 2C8",
      "city": "Burlington",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NewLife Fertility Centre, Burlington",
    "images": [
      {
        "id": "ca-on-newlife-fertility-centre-burlington-burlington-image-1",
        "url": "https://newlifefertility.com/wp-content/uploads/2024/11/Main-Banner.png",
        "name": "NewLife Fertility Centre, Burlington"
      },
      {
        "id": "ca-on-newlife-fertility-centre-burlington-burlington-image-2",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/07/Nival-scaled.png",
        "name": "attachment-full size-full wp-image-15397"
      },
      {
        "id": "ca-on-newlife-fertility-centre-burlington-burlington-image-3",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design33.png",
        "name": "attachment-large size-large wp-image-13007"
      },
      {
        "id": "ca-on-newlife-fertility-centre-burlington-burlington-image-4",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design31.png",
        "name": "attachment-large size-large wp-image-13005"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://newlifefertility.com/",
    "email": null,
    "phone": "9058967100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "NewLife Fertility Centre is Canada's leading fertility clinic, offering advanced treatments like IVF, egg freezing & IUI with expert care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-newlife-fertility-centre-concord-concord",
    "name": "NewLife Fertility Centre, Concord",
    "address": {
      "id": "addr-ca-on-newlife-fertility-centre-concord-concord",
      "address1": "8760 Jane Street",
      "address2": "Unit 101 Building A, Concord, ON L4K 4V3",
      "city": "Concord",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NewLife Fertility Centre, Concord",
    "images": [
      {
        "id": "ca-on-newlife-fertility-centre-concord-concord-image-1",
        "url": "https://newlifefertility.com/wp-content/uploads/2024/11/Main-Banner.png",
        "name": "NewLife Fertility Centre, Concord"
      },
      {
        "id": "ca-on-newlife-fertility-centre-concord-concord-image-2",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/07/Nival-scaled.png",
        "name": "attachment-full size-full wp-image-15397"
      },
      {
        "id": "ca-on-newlife-fertility-centre-concord-concord-image-3",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design33.png",
        "name": "attachment-large size-large wp-image-13007"
      },
      {
        "id": "ca-on-newlife-fertility-centre-concord-concord-image-4",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design31.png",
        "name": "attachment-large size-large wp-image-13005"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://newlifefertility.com/",
    "email": null,
    "phone": "9058967100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "NewLife Fertility Centre is Canada's leading fertility clinic, offering advanced treatments like IVF, egg freezing & IUI with expert care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-newlife-fertility-centre-hamilton-hamilton",
    "name": "NewLife Fertility Centre, Hamilton",
    "address": {
      "id": "addr-ca-on-newlife-fertility-centre-hamilton-hamilton",
      "address1": "1057 Main Street West",
      "address2": "Suite 102, Hamilton, ON L8S 1B7",
      "city": "Hamilton",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NewLife Fertility Centre, Hamilton",
    "images": [
      {
        "id": "ca-on-newlife-fertility-centre-hamilton-hamilton-image-1",
        "url": "https://newlifefertility.com/wp-content/uploads/2024/11/Main-Banner.png",
        "name": "NewLife Fertility Centre, Hamilton"
      },
      {
        "id": "ca-on-newlife-fertility-centre-hamilton-hamilton-image-2",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/07/Nival-scaled.png",
        "name": "attachment-full size-full wp-image-15397"
      },
      {
        "id": "ca-on-newlife-fertility-centre-hamilton-hamilton-image-3",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design33.png",
        "name": "attachment-large size-large wp-image-13007"
      },
      {
        "id": "ca-on-newlife-fertility-centre-hamilton-hamilton-image-4",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design31.png",
        "name": "attachment-large size-large wp-image-13005"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://newlifefertility.com/",
    "email": null,
    "phone": "9059728382",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "NewLife Fertility Centre is Canada's leading fertility clinic, offering advanced treatments like IVF, egg freezing & IUI with expert care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-newlife-fertility-centre-richmond-hill-richmond-hill",
    "name": "NewLife Fertility Centre, Richmond Hill",
    "address": {
      "id": "addr-ca-on-newlife-fertility-centre-richmond-hill-richmond-hill",
      "address1": "670 Highway 7 East",
      "address2": "Suite 8, Richmond Hill, ON L4B 3P2",
      "city": "Richmond Hill",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NewLife Fertility Centre, Richmond Hill",
    "images": [
      {
        "id": "ca-on-newlife-fertility-centre-richmond-hill-richmond-hill-image-1",
        "url": "https://newlifefertility.com/wp-content/uploads/2024/11/Main-Banner.png",
        "name": "NewLife Fertility Centre, Richmond Hill"
      },
      {
        "id": "ca-on-newlife-fertility-centre-richmond-hill-richmond-hill-image-2",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/07/Nival-scaled.png",
        "name": "attachment-full size-full wp-image-15397"
      },
      {
        "id": "ca-on-newlife-fertility-centre-richmond-hill-richmond-hill-image-3",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design33.png",
        "name": "attachment-large size-large wp-image-13007"
      },
      {
        "id": "ca-on-newlife-fertility-centre-richmond-hill-richmond-hill-image-4",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design31.png",
        "name": "attachment-large size-large wp-image-13005"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://newlifefertility.com/",
    "email": null,
    "phone": "9058967100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "NewLife Fertility Centre is Canada's leading fertility clinic, offering advanced treatments like IVF, egg freezing & IUI with expert care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-newlife-fertilty-centre-milton",
    "name": "NewLife Fertilty Centre",
    "address": {
      "id": "addr-ca-on-newlife-fertilty-centre-milton",
      "address1": "470 Bronte Street South",
      "address2": "Suite 201, Milton, ON L9T 2X6",
      "city": "Milton",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "NewLife Fertilty Centre",
    "images": [
      {
        "id": "ca-on-newlife-fertilty-centre-milton-image-1",
        "url": "https://newlifefertility.com/wp-content/uploads/2024/11/Main-Banner.png",
        "name": "NewLife Fertilty Centre"
      },
      {
        "id": "ca-on-newlife-fertilty-centre-milton-image-2",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/07/Nival-scaled.png",
        "name": "attachment-full size-full wp-image-15397"
      },
      {
        "id": "ca-on-newlife-fertilty-centre-milton-image-3",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design33.png",
        "name": "attachment-large size-large wp-image-13007"
      },
      {
        "id": "ca-on-newlife-fertilty-centre-milton-image-4",
        "url": "https://newlifefertility.com/wp-content/uploads/2025/01/Untitled-design31.png",
        "name": "attachment-large size-large wp-image-13005"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://newlifefertility.com/",
    "email": null,
    "phone": "9058967100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "NewLife Fertility Centre is Canada's leading fertility clinic, offering advanced treatments like IVF, egg freezing & IUI with expert care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-niagara-fertility-at-stoney-creek-stoney-creek",
    "name": "Niagara Fertility at Stoney Creek",
    "address": {
      "id": "addr-ca-on-niagara-fertility-at-stoney-creek-stoney-creek",
      "address1": "821 North Service Road, Unit 103",
      "address2": "Stoney Creek, ON L8E 0J7",
      "city": "Stoney Creek",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Niagara Fertility at Stoney Creek",
    "images": [
      {
        "id": "ca-on-niagara-fertility-at-stoney-creek-stoney-creek-image-1",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/ofn-doctor-patient.png",
        "name": "ofn-doctor-patient wp-image-2256"
      },
      {
        "id": "ca-on-niagara-fertility-at-stoney-creek-stoney-creek-image-2",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/og-image.jpg",
        "name": "Niagara Fertility at Stoney Creek"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://ontariofertilitynetwork.com/",
    "email": null,
    "phone": "9056623139",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Are you trying to conceive or struggling with infertility? Our fertility clinics & specialists in Ontario can help. Book your fertility assessment today.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-north-shore-fertility-centre-thunder-bay",
    "name": "North Shore Fertility Centre",
    "address": {
      "id": "addr-ca-on-north-shore-fertility-centre-thunder-bay",
      "address1": "194 Court Street North",
      "address2": "Thunder Bay, ON P7A 4V7",
      "city": "Thunder Bay",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "North Shore Fertility Centre",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": null,
    "email": null,
    "phone": "8073461000",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-ab-oasis-fertility-centre",
    "name": "Oasis Fertility Centre",
    "address": {
      "id": "addr-ca-ab-oasis-fertility-centre",
      "address1": "410 - 23 Sunpark Drive SE",
      "address2": null,
      "city": "Calgary",
      "state": "AB",
      "postalCode": "T2X 3V1",
      "country": "CA"
    },
    "headline": "Oasis Fertility Centre",
    "images": [
      {
        "id": "ca-ab-oasis-fertility-centre-image-1",
        "url": "https://oasisfertility.com/wp-content/uploads/2023/08/t1.webp",
        "name": "Platelet Rich Plasma Infusion in Calgary | Fertility clinic in Calgary | Fertility Testing Home 1 attachment-full size-full wp-image-91"
      },
      {
        "id": "ca-ab-oasis-fertility-centre-image-2",
        "url": "https://oasisfertility.com/wp-admin/admin-ajax.php?action=rank_math_overlay_thumb&id=1401&type=play&hash=d59d9eb25dc1fd2788a3db6d2f5474ab",
        "name": "Oasis Fertility Centre"
      },
      {
        "id": "ca-ab-oasis-fertility-centre-image-3",
        "url": "https://oasisfertility.com/wp-content/uploads/2023/08/rainbow.webp",
        "name": "LGBTQ2SIA+ Calgary attachment-full size-full wp-image-22"
      },
      {
        "id": "ca-ab-oasis-fertility-centre-image-4",
        "url": "https://oasisfertility.com/wp-content/uploads/2023/08/t2.webp",
        "name": "Intrauterine Insemination Calgary IUI Calgary Home 2 attachment-full size-full wp-image-92"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://oasisfertility.com/",
    "email": null,
    "phone": "403-910-7888",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Achieve your dream of starting or expanding your family at Oasis Fertility, a leading fertility clinic in Calgary. Personalized care and cutting-edge treatments",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-bc-olive-fertility-kelowna",
    "name": "Olive Fertility Centre - Kelowna",
    "address": {
      "id": "addr-ca-bc-olive-fertility-kelowna",
      "address1": "1630 Pandosy Street",
      "address2": "Suite 202",
      "city": "Kelowna",
      "state": "BC",
      "postalCode": "V1Y 1P7",
      "country": "CA"
    },
    "headline": "Olive Fertility Centre - Kelowna",
    "images": [
      {
        "id": "ca-bc-olive-fertility-kelowna-image-1",
        "url": "https://cdn.olivefertility.com/attachments/clt3qzdys02019iyl96u8ord4-olivefertility-laboratory-1.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-kelowna-image-2",
        "url": "https://cdn.olivefertility.com/attachments/clprqmhtk24l2b2ylby0f1i3d-olive-doctor-pic.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-kelowna-image-3",
        "url": "https://cdn.olivefertility.com/attachments/ckyd42wnd001irwzlv2wjledc-olive-hands049-hero-van.full.jpg",
        "name": "holding hands home page header w-full h-full h-full object-center object-cover"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.olivefertility.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "At Olive Fertility Centre, we offer personalized care for your fertility journey. Check our success rates and get life-changing results with us today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:15",
        "close": "16:00"
      },
      "tue": {
        "open": "07:15",
        "close": "16:00"
      },
      "wed": {
        "open": "07:15",
        "close": "16:00"
      },
      "thu": {
        "open": "07:15",
        "close": "16:00"
      },
      "fri": {
        "open": "07:15",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-bc-olive-fertility-surrey",
    "name": "Olive Fertility Centre - Surrey",
    "address": {
      "id": "addr-ca-bc-olive-fertility-surrey",
      "address1": "",
      "address2": null,
      "city": "Surrey",
      "state": "BC",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Olive Fertility Centre - Surrey",
    "images": [
      {
        "id": "ca-bc-olive-fertility-surrey-image-1",
        "url": "https://cdn.olivefertility.com/attachments/clt3qzdys02019iyl96u8ord4-olivefertility-laboratory-1.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-surrey-image-2",
        "url": "https://cdn.olivefertility.com/attachments/clprqmhtk24l2b2ylby0f1i3d-olive-doctor-pic.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-surrey-image-3",
        "url": "https://cdn.olivefertility.com/attachments/ckyd42wnd001irwzlv2wjledc-olive-hands049-hero-van.full.jpg",
        "name": "holding hands home page header w-full h-full h-full object-center object-cover"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.olivefertility.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "At Olive Fertility Centre, we offer personalized care for your fertility journey. Check our success rates and get life-changing results with us today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false,
    "schedule": {
      "mon": {
        "open": "07:15",
        "close": "16:00"
      },
      "tue": {
        "open": "07:15",
        "close": "16:00"
      },
      "wed": {
        "open": "07:15",
        "close": "16:00"
      },
      "thu": {
        "open": "07:15",
        "close": "16:00"
      },
      "fri": {
        "open": "07:15",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-bc-olive-fertility-vancouver",
    "name": "Olive Fertility Centre - Vancouver",
    "address": {
      "id": "addr-ca-bc-olive-fertility-vancouver",
      "address1": "555 West 12th Avenue",
      "address2": "East Tower, Suite 300",
      "city": "Vancouver",
      "state": "BC",
      "postalCode": "V5Z 3X7",
      "country": "CA"
    },
    "headline": "Olive Fertility Centre - Vancouver",
    "images": [
      {
        "id": "ca-bc-olive-fertility-vancouver-image-1",
        "url": "https://cdn.olivefertility.com/attachments/clt3qzdys02019iyl96u8ord4-olivefertility-laboratory-1.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-vancouver-image-2",
        "url": "https://cdn.olivefertility.com/attachments/clprqmhtk24l2b2ylby0f1i3d-olive-doctor-pic.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-vancouver-image-3",
        "url": "https://cdn.olivefertility.com/attachments/ckyd42wnd001irwzlv2wjledc-olive-hands049-hero-van.full.jpg",
        "name": "holding hands home page header w-full h-full h-full object-center object-cover"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.olivefertility.com/",
    "email": null,
    "phone": "604-559-9950",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "At Olive Fertility Centre, we offer personalized care for your fertility journey. Check our success rates and get life-changing results with us today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:15",
        "close": "16:00"
      },
      "tue": {
        "open": "07:15",
        "close": "16:00"
      },
      "wed": {
        "open": "07:15",
        "close": "16:00"
      },
      "thu": {
        "open": "07:15",
        "close": "16:00"
      },
      "fri": {
        "open": "07:15",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-bc-olive-fertility-victoria",
    "name": "Olive Fertility Centre - Victoria",
    "address": {
      "id": "addr-ca-bc-olive-fertility-victoria",
      "address1": "",
      "address2": null,
      "city": "Victoria",
      "state": "BC",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Olive Fertility Centre - Victoria",
    "images": [
      {
        "id": "ca-bc-olive-fertility-victoria-image-1",
        "url": "https://cdn.olivefertility.com/attachments/clt3qzdys02019iyl96u8ord4-olivefertility-laboratory-1.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-victoria-image-2",
        "url": "https://cdn.olivefertility.com/attachments/clprqmhtk24l2b2ylby0f1i3d-olive-doctor-pic.two-thirds.jpg",
        "name": "w-full h-full object-cover"
      },
      {
        "id": "ca-bc-olive-fertility-victoria-image-3",
        "url": "https://cdn.olivefertility.com/attachments/ckyd42wnd001irwzlv2wjledc-olive-hands049-hero-van.full.jpg",
        "name": "holding hands home page header w-full h-full h-full object-center object-cover"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.olivefertility.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "At Olive Fertility Centre, we offer personalized care for your fertility journey. Check our success rates and get life-changing results with us today!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false,
    "schedule": {
      "mon": {
        "open": "07:15",
        "close": "16:00"
      },
      "tue": {
        "open": "07:15",
        "close": "16:00"
      },
      "wed": {
        "open": "07:15",
        "close": "16:00"
      },
      "thu": {
        "open": "07:15",
        "close": "16:00"
      },
      "fri": {
        "open": "07:15",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-omega-fertility-center-inc-london",
    "name": "OMEGA Fertility Center Inc.",
    "address": {
      "id": "addr-ca-on-omega-fertility-center-inc-london",
      "address1": "373 Commissioners Road West",
      "address2": "London, ON N6J 1Y4",
      "city": "London",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "OMEGA Fertility Center Inc.",
    "images": [
      {
        "id": "ca-on-omega-fertility-center-inc-london-image-1",
        "url": "https://omegafertility.ca/fc/wp-content/uploads/andrology-mens-health-checkup-1-w760.jpg",
        "name": "img-responsive wp-image-52371"
      },
      {
        "id": "ca-on-omega-fertility-center-inc-london-image-2",
        "url": "https://omegafertility.ca/fc/wp-content/uploads/omega-social-banner-begin-a-new-life-v2.jpg",
        "name": "OMEGA Fertility Center Inc."
      },
      {
        "id": "ca-on-omega-fertility-center-inc-london-image-3",
        "url": "https://omegafertility.ca/fc/wp-content/uploads/omega-pride-flag-square-x100-e1532276490578.png",
        "name": "OMEGA Supports LGBTQ OMEGA Supports LGBTQ img-responsive wp-image-2814"
      },
      {
        "id": "ca-on-omega-fertility-center-inc-london-image-4",
        "url": "https://omegafertility.ca/fc/wp-content/uploads/in-vitro-fertilization-microscope-1-w760.jpg",
        "name": "img-responsive wp-image-52372"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://omegafertility.ca/",
    "email": null,
    "phone": "5196855559",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "At the OMEGA Fertility Center, we offer the most advanced fertility treatment through individualized and compassionate care, guided by the highest ethical standards.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-one-fertility-burlington-burlington",
    "name": "ONE Fertility Burlington",
    "address": {
      "id": "addr-ca-on-one-fertility-burlington-burlington",
      "address1": "3210 Harvester Road",
      "address2": "Burlington, ON L7N 3T1",
      "city": "Burlington",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "ONE Fertility Burlington",
    "images": [
      {
        "id": "ca-on-one-fertility-burlington-burlington-image-1",
        "url": "https://onefertility.com/wp-content/uploads/2021/09/Slider-1-1.jpg",
        "name": "A photograph of babies ls-bg"
      },
      {
        "id": "ca-on-one-fertility-burlington-burlington-image-2",
        "url": "https://onefertility.com/wp-content/uploads/2021/11/Ultrasound.jpg",
        "name": "ls-bg"
      },
      {
        "id": "ca-on-one-fertility-burlington-burlington-image-3",
        "url": "https://onefertility.com/wp-content/uploads/2021/09/Slider-3.jpg",
        "name": "A photogra ls-bg"
      },
      {
        "id": "ca-on-one-fertility-burlington-burlington-image-4",
        "url": "https://onefertility.com/wp-content/uploads/2021/09/Slider-4.jpg",
        "name": "ls-bg"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://onefertility.com/",
    "email": null,
    "phone": "9056344440",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-one-fertility-kitchener-waterloo-kitchener-waterloo",
    "name": "ONE Fertility Kitchener-Waterloo",
    "address": {
      "id": "addr-ca-on-one-fertility-kitchener-waterloo-kitchener-waterloo",
      "address1": "4271 King Street East",
      "address2": "Suite 200, Kitchener-Waterloo, ON N2P 2X7",
      "city": "Kitchener-Waterloo",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "ONE Fertility Kitchener-Waterloo",
    "images": [
      {
        "id": "ca-on-one-fertility-kitchener-waterloo-kitchener-waterloo-image-1",
        "url": "https://www.googleadservices.com/pagead/conversion/835972443/?label=O06BCLb5wXQQ29rPjgM&guid=ON&script=0",
        "name": "ONE Fertility Kitchener-Waterloo"
      },
      {
        "id": "ca-on-one-fertility-kitchener-waterloo-kitchener-waterloo-image-2",
        "url": "https://www.onefertilitykitchenerwaterloo.com/wp-content/uploads/2020/08/cropped-banner_images_2.jpg",
        "name": "ONE Fertility Kitchener-Waterloo"
      },
      {
        "id": "ca-on-one-fertility-kitchener-waterloo-kitchener-waterloo-image-3",
        "url": "https://www.onefertilitykitchenerwaterloo.com/wp-content/themes/responsive_1/images/banner_images_2.webp",
        "name": "Hope"
      },
      {
        "id": "ca-on-one-fertility-kitchener-waterloo-kitchener-waterloo-image-4",
        "url": "https://www.onefertilitykitchenerwaterloo.com/wp-content/themes/responsive_1/images/banner_images_1.webp",
        "name": "Support"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.onefertilitykitchenerwaterloo.com/",
    "email": null,
    "phone": "5196500011",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "ONE Fertility Kitchener Waterloo is a state-of-the-art fertility and IVF clinic providing expert fertility care, treatment, and counseling in Ontario and across Canada.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": {
        "open": "08:00",
        "close": "12:00"
      },
      "sun": {
        "open": "08:00",
        "close": "12:00"
      }
    }
  },
  {
    "id": "ca-qc-originelle-fertility",
    "name": "OriginElle Fertility Clinic & Women's Health Centre",
    "address": {
      "id": "addr-ca-qc-originelle-fertility",
      "address1": "",
      "address2": null,
      "city": "Montreal",
      "state": "QC",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "OriginElle Fertility Clinic & Women's Health Centre",
    "images": [
      {
        "id": "ca-qc-originelle-fertility-image-1",
        "url": "https://originelle.com/wp-content/uploads/elementor/thumbs/ultrasound-diagnostic-stomach-abdominal-woman-clinic-closeup-view-doctor-runs-ultrasound-sensor-patient-s-girl-tummy-looks-image-screen-diagnosis-internal-organs-r3i2zz9gfrudvjcfpn2dame7h653o3nmrcbxtky8ic.jpg",
        "name": "Ultrasound Diagnostic ultrasound-diagnostic-stomach-abdominal-woman-clinic-closeup-view-doctor-runs-ultrasound-sensor-patient-s-girl-tummy-looks-image-screen-diagnosis-internal-organs"
      },
      {
        "id": "ca-qc-originelle-fertility-image-2",
        "url": "https://originelle.com/wp-content/uploads/2025/03/60e2bb36-73a3-11e9-9f79-0e7266730414.jpg",
        "name": "Fertility Clinic attachment-large size-large wp-image-255"
      },
      {
        "id": "ca-qc-originelle-fertility-image-3",
        "url": "https://originelle.com/wp-content/uploads/2025/05/Picture2.jpg",
        "name": "OriginElle Fertility Clinic swiper-slide-image"
      },
      {
        "id": "ca-qc-originelle-fertility-image-4",
        "url": "https://originelle.com/wp-content/uploads/2025/03/DRTAN_1738304703-768x1024.jpg",
        "name": "Lab attachment-large size-large wp-image-256"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://originelle.com/",
    "email": null,
    "phone": "514-600-1980",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Looking for the best fertility clinic in Quebec, Montreal, or Ottawa? OriginElle is a trusted Montreal fertility clinic offering advanced IVF and personalized fertility care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "ca-on-ottawa-fertility-centre-ottawa",
    "name": "Ottawa Fertility Centre",
    "address": {
      "id": "addr-ca-on-ottawa-fertility-centre-ottawa",
      "address1": "955 Green Valley Crescent",
      "address2": "Suite 200, Ottawa, ON K2C 3V4",
      "city": "Ottawa",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Ottawa Fertility Centre",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.conceive.ca/",
    "email": null,
    "phone": "6136863378",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-qc-ovo-fertility-montreal",
    "name": "OVO Fertility - Montreal",
    "address": {
      "id": "addr-ca-qc-ovo-fertility-montreal",
      "address1": "8000 Boulevard Décarie",
      "address2": "Suite 100",
      "city": "Montreal",
      "state": "QC",
      "postalCode": "H4P 2S4",
      "country": "CA"
    },
    "headline": "OVO Fertility - Montreal",
    "images": [
      {
        "id": "ca-qc-ovo-fertility-montreal-image-1",
        "url": "https://cdn.cliniqueovo.com/attachments/cktshd42200shpgzlbe87hpi7-services-labo-slider.full.png",
        "name": "image-services-labo-slider4 w-full h-full object-left object-contain"
      },
      {
        "id": "ca-qc-ovo-fertility-montreal-image-2",
        "url": "https://cdn.cliniqueovo.com/attachments/cktbz3ein00887yzld9ixx0dn-9.full.png",
        "name": "image-9 w-full h-full object-right object-contain"
      },
      {
        "id": "ca-qc-ovo-fertility-montreal-image-3",
        "url": "https://cdn.cliniqueovo.com/attachments/cktbz40nt00927yzldcudzfpg-13.full.png",
        "name": "image-13 w-full h-full object-right object-contain"
      },
      {
        "id": "ca-qc-ovo-fertility-montreal-image-4",
        "url": "https://cdn.cliniqueovo.com/attachments/cktshd4tk00sipgzl37fi7zue-r-n-d-slider.full.png",
        "name": "image-r-n-d-slider3 w-full h-full object-right object-contain"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.cliniqueovo.com/",
    "email": null,
    "phone": "514-798-2000",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "clinique ovo est un groupe médical basé à Montréal spécialisé dans la fertilité, les dons de sperme et d'ovules, ainsi que les services de laboratoire. Laissez-nous vous aider dans votre parcours vers la fertilité.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-bc-pcrm-burnaby",
    "name": "Pacific Centre for Reproductive Medicine - Burnaby",
    "address": {
      "id": "addr-ca-bc-pcrm-burnaby",
      "address1": "4601 Canada Way",
      "address2": "Suite 500",
      "city": "Burnaby",
      "state": "BC",
      "postalCode": "V5G 4X7",
      "country": "CA"
    },
    "headline": "Pacific Centre for Reproductive Medicine - Burnaby",
    "images": [
      {
        "id": "ca-bc-pcrm-burnaby-image-1",
        "url": "https://www.pacificfertility.ca/media/site/8da7fb6955-1756410487/pcrm-default.png",
        "name": "Pacific Centre for Reproductive Medicine - Burnaby"
      },
      {
        "id": "ca-bc-pcrm-burnaby-image-2",
        "url": "https://www.pacificfertility.ca/media/pages/home/575d3fc60b-1756410486/media.png",
        "name": "bg-container"
      },
      {
        "id": "ca-bc-pcrm-burnaby-image-3",
        "url": "https://www.pacificfertility.ca/media/pages/home/d6f36df096-1756410487/video-thumbnail.png",
        "name": "bg-container"
      },
      {
        "id": "ca-bc-pcrm-burnaby-image-4",
        "url": "https://www.pacificfertility.ca/media/pages/about-pcrm/3d09b15ae7-1756410486/about-1.jpg",
        "name": "bg-container"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://pacificfertility.ca/",
    "email": null,
    "phone": "604-422-7276",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Pacific Centre For Reproductive Medicine is a leader in exceptional IVF &amp; fertility treatment. Visit our clinics in Greater Vancouver, Edmonton &amp; Victoria.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-ab-pcrm-edmonton",
    "name": "Pacific Centre for Reproductive Medicine - Edmonton",
    "address": {
      "id": "addr-ca-ab-pcrm-edmonton",
      "address1": "9888 Jasper Avenue",
      "address2": "3rd Floor",
      "city": "Edmonton",
      "state": "AB",
      "postalCode": "T5J 5C6",
      "country": "CA"
    },
    "headline": "Pacific Centre for Reproductive Medicine - Edmonton",
    "images": [
      {
        "id": "ca-ab-pcrm-edmonton-image-1",
        "url": "https://www.pacificfertility.ca/media/site/8da7fb6955-1756410487/pcrm-default.png",
        "name": "Pacific Centre for Reproductive Medicine - Edmonton"
      },
      {
        "id": "ca-ab-pcrm-edmonton-image-2",
        "url": "https://www.pacificfertility.ca/media/pages/home/575d3fc60b-1756410486/media.png",
        "name": "bg-container"
      },
      {
        "id": "ca-ab-pcrm-edmonton-image-3",
        "url": "https://www.pacificfertility.ca/media/pages/home/d6f36df096-1756410487/video-thumbnail.png",
        "name": "bg-container"
      },
      {
        "id": "ca-ab-pcrm-edmonton-image-4",
        "url": "https://www.pacificfertility.ca/media/pages/about-pcrm/3d09b15ae7-1756410486/about-1.jpg",
        "name": "bg-container"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://pacificfertility.ca/",
    "email": null,
    "phone": "780-990-4442",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Pacific Centre For Reproductive Medicine is a leader in exceptional IVF &amp; fertility treatment. Visit our clinics in Greater Vancouver, Edmonton &amp; Victoria.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-pollin-fertility-clinic-toronto",
    "name": "Pollin Fertility Clinic",
    "address": {
      "id": "addr-ca-on-pollin-fertility-clinic-toronto",
      "address1": "2360 Yonge Street",
      "address2": "2 nd Floor, Toronto, ON M4P 2E6",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Pollin Fertility Clinic",
    "images": [
      {
        "id": "ca-on-pollin-fertility-clinic-toronto-image-1",
        "url": "https://cdn.prod.website-files.com/64de392d03a7d7292c242162/6564b4f84a43ddc062d01667_64ef291efed44358972534a7_V4_FertilityClinic_View08_IVF%20Lab%20copy-p-2000%20(1).webp",
        "name": "Pollin Fertility clinic, laboratory image-10"
      },
      {
        "id": "ca-on-pollin-fertility-clinic-toronto-image-2",
        "url": "https://cdn.prod.website-files.com/64de392d03a7d7292c242162/6560bc4356883c569fb8ad32_64ef291efed44358972534a7_V4_FertilityClinic_View08_IVF%20Lab%20copy-p-2000.webp",
        "name": "Pollin's Lab image-20 left _500-px-mobile"
      },
      {
        "id": "ca-on-pollin-fertility-clinic-toronto-image-3",
        "url": "https://cdn.prod.website-files.com/64de392d03a7d7292c242162/66266347169397d0f6c10cc3_DoctorsOffice_101%20copy.webp",
        "name": "Interior at Pollin Fertility, Yonge and Eglinton, Midtown Toronto image-9 _40 bottom-padding"
      },
      {
        "id": "ca-on-pollin-fertility-clinic-toronto-image-4",
        "url": "https://cdn.prod.website-files.com/64de392d03a7d7292c242162/6564b37ef93617346d24747d_64ef2fd50be439b5ab06f45a_V3_Fertility%20Clinic_View07_Reception%20Lobby_Option%20C%20copy-p-2000.webp",
        "name": "Pollin Fertility Clinic"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.pollinfertility.com",
    "email": null,
    "phone": "4163423552",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Toronto fertility clinic offering IVF, egg freezing & funded cycles. No waitlist — most patients start treatment within weeks. Book a consultation.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "15:00"
      },
      "tue": {
        "open": "07:30",
        "close": "15:00"
      },
      "wed": {
        "open": "07:30",
        "close": "15:00"
      },
      "thu": {
        "open": "07:30",
        "close": "15:00"
      },
      "fri": {
        "open": "07:30",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-qc-procrea-montreal",
    "name": "Procrea Fertility Centre - Montreal",
    "address": {
      "id": "addr-ca-qc-procrea-montreal",
      "address1": "1361 Avenue Beaumont",
      "address2": "Suite 301",
      "city": "Montreal",
      "state": "QC",
      "postalCode": "H3P 2W3",
      "country": "CA"
    },
    "headline": "Procrea Fertility Centre - Montreal",
    "images": [
      {
        "id": "ca-qc-procrea-montreal-image-1",
        "url": "https://cdn.procrea.ca/attachments/xlt3ke4v6f9h8xs218frbka1-stock-photo-travel-hike-forest-nature-hiker-woman-walking-in-canadian-woods-in-fall-autumn-season-by-beaver-1517892458-1.full.png",
        "name": "building tfp-image-widget"
      },
      {
        "id": "ca-qc-procrea-montreal-image-2",
        "url": "https://cdn.procrea.ca/attachments/o80vl3nbp8jns05avuewuh8k-pbl-procreaapril2024-590-1.full.png",
        "name": "procrea team tfp-image-widget"
      },
      {
        "id": "ca-qc-procrea-montreal-image-3",
        "url": "https://cdn.procrea.ca/attachments/v1khue7o3434ip4mtd80gufj-screenshot-2024-10-10-at-7-50-33-am.full.png",
        "name": "tfp-image-widget"
      },
      {
        "id": "ca-qc-procrea-montreal-image-4",
        "url": "https://cdn.procrea.ca/attachments/x8uerhb0pw1m0wf8o4d1z67y-photo-1517037126752-acf49bfda61a.full.jpg",
        "name": "tfp-image-widget"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.procrea.ca/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Chez PROCREA Québec, nous offrons des services de fertilité adaptés à votre parcours, avec expertise, écoute et accompagnement personnalisé.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-qc-procrea-quebec",
    "name": "Procrea Fertility Centre - Quebec City",
    "address": {
      "id": "addr-ca-qc-procrea-quebec",
      "address1": "5600 Boulevard des Galeries",
      "address2": null,
      "city": "Quebec City",
      "state": "QC",
      "postalCode": "G2K 2H6",
      "country": "CA"
    },
    "headline": "Procrea Fertility Centre - Quebec City",
    "images": [
      {
        "id": "ca-qc-procrea-quebec-image-1",
        "url": "https://cdn.procrea.ca/attachments/xlt3ke4v6f9h8xs218frbka1-stock-photo-travel-hike-forest-nature-hiker-woman-walking-in-canadian-woods-in-fall-autumn-season-by-beaver-1517892458-1.full.png",
        "name": "building tfp-image-widget"
      },
      {
        "id": "ca-qc-procrea-quebec-image-2",
        "url": "https://cdn.procrea.ca/attachments/o80vl3nbp8jns05avuewuh8k-pbl-procreaapril2024-590-1.full.png",
        "name": "procrea team tfp-image-widget"
      },
      {
        "id": "ca-qc-procrea-quebec-image-3",
        "url": "https://cdn.procrea.ca/attachments/v1khue7o3434ip4mtd80gufj-screenshot-2024-10-10-at-7-50-33-am.full.png",
        "name": "tfp-image-widget"
      },
      {
        "id": "ca-qc-procrea-quebec-image-4",
        "url": "https://cdn.procrea.ca/attachments/x8uerhb0pw1m0wf8o4d1z67y-photo-1517037126752-acf49bfda61a.full.jpg",
        "name": "tfp-image-widget"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["fr", "en"],
    "clinicType": "Network & group",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.procrea.ca/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Chez PROCREA Québec, nous offrons des services de fertilité adaptés à votre parcours, avec expertise, écoute et accompagnement personnalisé.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-ab-regional-fertility-program",
    "name": "Regional Fertility Program",
    "address": {
      "id": "addr-ca-ab-regional-fertility-program",
      "address1": "1620 29 Street NW",
      "address2": "Suite 300",
      "city": "Calgary",
      "state": "AB",
      "postalCode": "T2N 4L7",
      "country": "CA"
    },
    "headline": "Regional Fertility Program",
    "images": [
      {
        "id": "ca-ab-regional-fertility-program-image-1",
        "url": "https://regionalfertilityprogram.ca/wp-content/uploads/2022/09/webteam.agency.png",
        "name": "Regional Fertility Program"
      },
      {
        "id": "ca-ab-regional-fertility-program-image-2",
        "url": "https://regionalfertilityprogram.ca/wp-content/uploads/2021/09/team-foong.png",
        "name": "Regional Fertility Program"
      },
      {
        "id": "ca-ab-regional-fertility-program-image-3",
        "url": "https://regionalfertilityprogram.ca/wp-content/uploads/2021/09/Team-Wong.png",
        "name": "Regional Fertility Program"
      },
      {
        "id": "ca-ab-regional-fertility-program-image-4",
        "url": "https://regionalfertilityprogram.ca/wp-content/uploads/2021/09/Team-min.png",
        "name": "Regional Fertility Program"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.regionalfertilityprogram.ca/",
    "email": null,
    "phone": "403-284-9444",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Regional Fertility Program is a leading fertility clinic in Calgary, providing exceptional IVF outcomes to aspiring parents across Alberta and beyond.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-the-reproductive-care-centre-rcc-mississauga",
    "name": "The Reproductive Care Centre ( RCC )",
    "address": {
      "id": "addr-ca-on-the-reproductive-care-centre-rcc-mississauga",
      "address1": "2180 Meadowvale Boulevard",
      "address2": "Mississauga, ON L5N 5S3",
      "city": "Mississauga",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "The Reproductive Care Centre ( RCC )",
    "images": [
      {
        "id": "ca-on-the-reproductive-care-centre-rcc-mississauga-image-1",
        "url": "https://cdn.rccfertility.com/attachments/n02vw38s3u4svpkmf7vivazl-rcc-missasauga-location.full.png",
        "name": "map view of the RCC Fertility clinic"
      },
      {
        "id": "ca-on-the-reproductive-care-centre-rcc-mississauga-image-2",
        "url": "https://cdn.rccfertility.com/attachments/ym9sa5qs5foz7iewlfpt2xkv-rcc-oakville-location.full.png",
        "name": "map view of oakville rcc location"
      },
      {
        "id": "ca-on-the-reproductive-care-centre-rcc-mississauga-image-3",
        "url": "https://cdn.rccfertility.com/attachments/ep0rergvg9c23dnhuyaafit4-fza7apjqxct72i0b4mivgt9b-rcc-fertility-team-photo.0.0.2375.2314.full.jpg",
        "name": "The Reproductive Care Centre ( RCC )"
      },
      {
        "id": "ca-on-the-reproductive-care-centre-rcc-mississauga-image-4",
        "url": "https://cdn.rccfertility.com/attachments/jv6h24uvzf0s70ajfqkd5inh-rcc-hero-image.max.webp",
        "name": "The Reproductive Care Centre ( RCC )"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.rccfertility.com/",
    "email": null,
    "phone": "9058169822",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:00"
      },
      "tue": {
        "open": "07:00",
        "close": "15:00"
      },
      "wed": {
        "open": "07:00",
        "close": "15:00"
      },
      "thu": {
        "open": "07:00",
        "close": "15:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "ca-on-toronto-centre-for-advanced-reproductive-technology-tcart-trio-fertility-waterloo-waterloo",
    "name": "Toronto Centre for Advanced Reproductive Technology ( TCART ) TRIO Fertility – Waterloo",
    "address": {
      "id": "addr-ca-on-toronto-centre-for-advanced-reproductive-technology-tcart-trio-fertility-waterloo-waterloo",
      "address1": "430 The Boardwalk",
      "address2": "Waterloo, ON N2J 3Z4",
      "city": "Waterloo",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Toronto Centre for Advanced Reproductive Technology ( TCART ) TRIO Fertility – Waterloo",
    "images": [
      {
        "id": "ca-on-toronto-centre-for-advanced-reproductive-technology-tcart-trio-fertility-waterloo-waterloo-image-1",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/ofn-doctor-patient.png",
        "name": "ofn-doctor-patient wp-image-2256"
      },
      {
        "id": "ca-on-toronto-centre-for-advanced-reproductive-technology-tcart-trio-fertility-waterloo-waterloo-image-2",
        "url": "https://ontariofertilitynetwork.com/wp-content/uploads/og-image.jpg",
        "name": "Toronto Centre for Advanced Reproductive Technology ( TCART ) TRIO Fertility – Waterloo"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "https://ontariofertilitynetwork.com/locations/trio-kitchener-waterloo-fertility-clinic/",
    "email": null,
    "phone": "5195851796",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Are you trying to conceive or struggling with infertility? Our fertility clinics & specialists in Ontario can help. Book your fertility assessment today.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-trio-fertility-toronto",
    "name": "TRIO Fertility",
    "address": {
      "id": "addr-ca-on-trio-fertility-toronto",
      "address1": "655 Bay Street,",
      "address2": "11th and 18th floor, Toronto, ON M5G 2K4",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "TRIO Fertility",
    "images": [
      {
        "id": "ca-on-trio-fertility-toronto-image-1",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:568/h:787/q:84/f:best/ig:avif/https://triofertility.com/storage/TRIO-receptionist-smiling.png",
        "name": "A photograph of a smiling TRIO receptionist. attachment-full size-full wp-image-505102"
      },
      {
        "id": "ca-on-trio-fertility-toronto-image-2",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:700/h:386/q:84/f:best/ig:avif/https://triofertility.com/storage/advanced-fertility-treatments-lab-1.jpg",
        "name": "TRIO Fertility"
      },
      {
        "id": "ca-on-trio-fertility-toronto-image-3",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:700/h:386/q:84/f:best/ig:avif/https://triofertility.com/storage/specialty-fertility-programs-lab-tech.jpg",
        "name": "TRIO Fertility"
      },
      {
        "id": "ca-on-trio-fertility-toronto-image-4",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:544/h:300/q:84/f:best/ig:avif/https://triofertility.com/storage/Fertility-Assessment-with-TRIO-Physician.png",
        "name": "TRIO Fertility"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://triofertility.com/",
    "email": null,
    "phone": "4165060804",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "TRIO is Canada's leading fertility clinic with 10 locations across Ontario. As a patient, you’ll get access to the newest technologies and fertility treatments.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-trio-fertility-burlington-burlington",
    "name": "TRIO Fertility Burlington",
    "address": {
      "id": "addr-ca-on-trio-fertility-burlington-burlington",
      "address1": "3115 Harvester Road",
      "address2": "Suite 301, Burlington, ON L7N 3N8",
      "city": "Burlington",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "TRIO Fertility Burlington",
    "images": [
      {
        "id": "ca-on-trio-fertility-burlington-burlington-image-1",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:568/h:787/q:84/f:best/ig:avif/https://triofertility.com/storage/TRIO-receptionist-smiling.png",
        "name": "A photograph of a smiling TRIO receptionist. attachment-full size-full wp-image-505102"
      },
      {
        "id": "ca-on-trio-fertility-burlington-burlington-image-2",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:700/h:386/q:84/f:best/ig:avif/https://triofertility.com/storage/advanced-fertility-treatments-lab-1.jpg",
        "name": "TRIO Fertility Burlington"
      },
      {
        "id": "ca-on-trio-fertility-burlington-burlington-image-3",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:700/h:386/q:84/f:best/ig:avif/https://triofertility.com/storage/specialty-fertility-programs-lab-tech.jpg",
        "name": "TRIO Fertility Burlington"
      },
      {
        "id": "ca-on-trio-fertility-burlington-burlington-image-4",
        "url": "https://mlaigdkgbrip.i.optimole.com/cb:u1Iz~3e665/w:544/h:300/q:84/f:best/ig:avif/https://triofertility.com/storage/Fertility-Assessment-with-TRIO-Physician.png",
        "name": "TRIO Fertility Burlington"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.triofertility.com",
    "email": null,
    "phone": "9057313860",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "TRIO is Canada's leading fertility clinic with 10 locations across Ontario. As a patient, you’ll get access to the newest technologies and fertility treatments.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-tripod-fertility-north-york",
    "name": "Tripod Fertility",
    "address": {
      "id": "addr-ca-on-tripod-fertility-north-york",
      "address1": "2225 Sheppard Avenue East",
      "address2": "Suite 901 North York, ON M2J 5C2",
      "city": "North York",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Tripod Fertility",
    "images": [
      {
        "id": "ca-on-tripod-fertility-north-york-image-1",
        "url": "https://www.tripodfertility.com/wp-content/uploads/2024/10/home-ivf.jpg",
        "name": "Tripod Fertility"
      },
      {
        "id": "ca-on-tripod-fertility-north-york-image-2",
        "url": "https://www.tripodfertility.com/wp-content/uploads/2024/10/home-egg-freezing.jpg",
        "name": "Tripod Fertility"
      },
      {
        "id": "ca-on-tripod-fertility-north-york-image-3",
        "url": "https://www.tripodfertility.com/wp-content/uploads/2024/10/home-lgbtq.jpg",
        "name": "Tripod Fertility"
      },
      {
        "id": "ca-on-tripod-fertility-north-york-image-4",
        "url": "https://www.tripodfertility.com/wp-content/uploads/2024/09/Prenatal1.webp",
        "name": "Tripod Fertility"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.tripodfertility.com",
    "email": null,
    "phone": "9052013420",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Tripod Fertility is a leading fertility clinic in Toronto, specializing in IVF treatments. If you're looking for a fertility centre near you, trust our expert care & advanced solutions.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "17:00"
      },
      "tue": {
        "open": "07:00",
        "close": "17:00"
      },
      "wed": {
        "open": "07:00",
        "close": "17:00"
      },
      "thu": {
        "open": "07:00",
        "close": "17:00"
      },
      "fri": {
        "open": "07:00",
        "close": "15:00"
      },
      "sat": {
        "open": "07:00",
        "close": "12:00"
      },
      "sun": {
        "open": "07:00",
        "close": "12:00"
      }
    }
  },
  {
    "id": "ca-on-twig-fertility-toronto",
    "name": "Twig Fertility",
    "address": {
      "id": "addr-ca-on-twig-fertility-toronto",
      "address1": "313 Eglinton Avenue West",
      "address2": "Toronto, ON M5N 1A1",
      "city": "Toronto",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Twig Fertility",
    "images": [
      {
        "id": "ca-on-twig-fertility-toronto-image-1",
        "url": "https://twigfertility.com/wp-content/uploads/2025/09/Toronto-Location-Component.jpg",
        "name": "Twig Fertility"
      },
      {
        "id": "ca-on-twig-fertility-toronto-image-2",
        "url": "https://twigfertility.com/wp-content/uploads/2025/09/Vancouver-Location-Component.jpg",
        "name": "Twig Fertility"
      },
      {
        "id": "ca-on-twig-fertility-toronto-image-3",
        "url": "https://twigfertility.com/wp-content/uploads/2021/09/Homepage_Header1-scaled.jpg",
        "name": "Twig Fertility"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.twigfertility.com",
    "email": null,
    "phone": "4168558944",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Every nest starts with a twig. Twig Fertility is the next generation of fertility care.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "17:00"
      },
      "tue": {
        "open": "07:00",
        "close": "17:00"
      },
      "wed": {
        "open": "07:00",
        "close": "17:00"
      },
      "thu": {
        "open": "07:00",
        "close": "17:00"
      },
      "fri": {
        "open": "07:00",
        "close": "17:00"
      },
      "sat": {
        "open": "07:00",
        "close": "15:00"
      },
      "sun": null
    }
  },
  {
    "id": "ca-bc-ubc-centre-for-reproductive-health",
    "name": "UBC Centre for Reproductive Health",
    "address": {
      "id": "addr-ca-bc-ubc-centre-for-reproductive-health",
      "address1": "4500 Oak Street",
      "address2": "D600",
      "city": "Vancouver",
      "state": "BC",
      "postalCode": "V6H 3N1",
      "country": "CA"
    },
    "headline": "UBC Centre for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Hospital-based",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.ubcfertility.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-bc-victoria-fertility-centre",
    "name": "Victoria Fertility Centre",
    "address": {
      "id": "addr-ca-bc-victoria-fertility-centre",
      "address1": "4400 Chatterton Way",
      "address2": "Suite 207",
      "city": "Victoria",
      "state": "BC",
      "postalCode": "V8X 5J2",
      "country": "CA"
    },
    "headline": "Victoria Fertility Centre",
    "images": [
      {
        "id": "ca-bc-victoria-fertility-centre-image-1",
        "url": "https://static.hugedomains.com/images/hdv3-img/og_hugedomains.png",
        "name": "Victoria Fertility Centre"
      },
      {
        "id": "ca-bc-victoria-fertility-centre-image-2",
        "url": "https://static.hugedomains.com/images/hdv3-img/favorite-header.png",
        "name": "Victoria Fertility Centre"
      },
      {
        "id": "ca-bc-victoria-fertility-centre-image-3",
        "url": "https://static.hugedomains.com/images/hdv3-img/cart.png",
        "name": "Victoria Fertility Centre"
      },
      {
        "id": "ca-bc-victoria-fertility-centre-image-4",
        "url": "https://static.hugedomains.com/images/hdv3-img/30daysmallico.png",
        "name": "Victoria Fertility Centre"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.victoriafertility.com/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Premium domains add authority to your site. Transparent pricing. 1 year WHOIS privacy included. 30-day money back guarantee.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-victory-reproductive-care-windsor",
    "name": "Victory Reproductive Care",
    "address": {
      "id": "addr-ca-on-victory-reproductive-care-windsor",
      "address1": "8100 Twin Oaks Drive",
      "address2": "Windsor, ON N8N 5C2",
      "city": "Windsor",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Victory Reproductive Care",
    "images": [
      {
        "id": "ca-on-victory-reproductive-care-windsor-image-1",
        "url": "https://i.ytimg.com/vi/0amHpLkhMuQ/maxresdefault.jpg",
        "name": "Doctor Reacts to House Of The Dragon's Birth Scene ayg-thumbnail-image"
      },
      {
        "id": "ca-on-victory-reproductive-care-windsor-image-2",
        "url": "https://www.drvictory.com/wp-content/plugins/revslider/public/assets/assets/dummy.png",
        "name": "banner-bg rev-slidebg tp-rs-img rs-lazyload"
      },
      {
        "id": "ca-on-victory-reproductive-care-windsor-image-3",
        "url": "https://www.drvictory.com/wp-content/uploads/2022/01/img-1.png",
        "name": "img-with-animation skip-lazy"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.drvictory.com/",
    "email": null,
    "phone": "5199446400",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "ca-on-victory-reproductive-care-sarnia-sarnia",
    "name": "Victory Reproductive Care (Sarnia)",
    "address": {
      "id": "addr-ca-on-victory-reproductive-care-sarnia-sarnia",
      "address1": "105-704 Mara Street",
      "address2": "Point Edward, ON N7V 1X4",
      "city": "Sarnia",
      "state": "ON",
      "postalCode": "",
      "country": "CA"
    },
    "headline": "Victory Reproductive Care (Sarnia)",
    "images": [
      {
        "id": "ca-on-victory-reproductive-care-sarnia-sarnia-image-1",
        "url": "https://i.ytimg.com/vi/0amHpLkhMuQ/maxresdefault.jpg",
        "name": "Doctor Reacts to House Of The Dragon's Birth Scene ayg-thumbnail-image"
      },
      {
        "id": "ca-on-victory-reproductive-care-sarnia-sarnia-image-2",
        "url": "https://www.drvictory.com/wp-content/plugins/revslider/public/assets/assets/dummy.png",
        "name": "banner-bg rev-slidebg tp-rs-img rs-lazyload"
      },
      {
        "id": "ca-on-victory-reproductive-care-sarnia-sarnia-image-3",
        "url": "https://www.drvictory.com/wp-content/uploads/2022/01/img-1.png",
        "name": "img-with-animation skip-lazy"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IUI"],
    "website": "http://www.drvictory.com",
    "email": null,
    "phone": "5194916080",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Ontario Fertility Program",
    "outcomeSourceType": "public-funding-program",
    "lastReportYear": 2026,
    "publicNotes": "Participates in Ontario Fertility Program funded services.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  }
]
